import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useReactToPrint } from 'react-to-print';

import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
//import "datatables.net-dt/css/jquery.dataTables.min.css";
import Header from './Header';
import logo from './images/icons/logo.JPG'; // Import your image here
import {
  faCheck,
  faTimes,
  faInfoCircle,
  faRefresh, faSave, faKey, faCheckCircle 
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


const Dashboardss = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;
let userCompanyID = window.userCompanyID;
//let userID = window.userID;
let userEmail = window.userEmail;
let userType = window.userType;

let userID = localStorage.getItem('userID')
if(userID === 'Admin'){
  userID = 1;
}
userID = JSON.parse(userID)
  
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-ZM', { style: 'currency', currency: 'ZMW' }).format(amount);
  };

  const formatCurrencyTable = (amount) => {
    // Convert amount to a number if it's not already
    const number = typeof amount === 'number' ? amount : parseFloat(amount);
    return new Intl.NumberFormat('en-ZM', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(number);
  };

  const generatePDF = () => {

};

const generatePDFAndSendEmail = () => {

};

  //email
  let [business_locationIDMain, setBusiness_locationIDMain] = useState('');

  let [businessLocationsHouses, setBusinessLocationsHouses] = useState([]);
  let [businessLocationsPlots, setBusinessLocationsPlots] = useState([]);
  const [businessLocations, setBusinessLocations] = useState([]);

  const business_locationIDMainBTN = () => {
    localStorage.setItem('business_locationIDMain', business_locationIDMain);
//alert(business_locationIDMain);
  };

useEffect(() => {
  // Create formData object
  const formData = new FormData();
  formData.append("apiType", 'getBusinessLocationOnUploadForm');
  formData.append("companyID", userCompanyID);
  formData.append("location", '');
  // Fetch plot options from the backend using POST method
  axios.post(`${server_app_api_php}/server/index.php`, formData)
    .then(response => {
      setBusinessLocations(response.data);
    })
    .catch(error => {
      //alert("There was an error fetching the Business Locations!", error);
    });
  }, []);

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationHousesOnUploadForm');
    formData.append("companyID", userCompanyID);
    formData.append("location", '');
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setBusinessLocationsHouses(response.data);
      })
      .catch(error => {
        //alert("There was an error fetching the Business Locations!", error);
      });
    }, []);

    useEffect(() => {
      // Create formData object
      const formData = new FormData();
      formData.append("apiType", 'getBusinessLocationPlotsOnUploadForm');
      formData.append("companyID", userCompanyID);
      formData.append("location", '');
      // Fetch plot options from the backend using POST method
      axios.post(`${server_app_api_php}/server/index.php`, formData)
        .then(response => {
          setBusinessLocationsPlots(response.data);
        })
        .catch(error => {
          //alert("There was an error fetching the Business Locations!", error);
        });
      }, []);

  const [dataPlotsDetailedStatement, setDataPlotsDetailedStatement] = useState({
    columns: [
      { label: 'SN', field: 'sn' },
      { label: 'Location', field: 'businessLocationName' },
      { label: 'Name', field: 'name' },
      { label: 'Plot Number', field: 'plotNumber' },
      { label: 'Amount', field: 'amountPaid' },
      { label: 'Phone', field: 'customersPhone' },
      { label: 'Date Paid', field: 'datePaid' },
      { label: 'Action', field: 'action' },
    ],
    rows: [],
  });
  const [totalAmountPlotsDetailedStatement, setTotalAmountPlotsDetailedStatement] = useState(0);
  const [filteredDataPlotsDetailedStatement, setFilteredDataPlotsDetailedStatement] = useState([]);
  const [entriesPlotsDetailedStatement, setEntriesPlotsDetailedStatement] = useState(5); // Number of entries per page
  const [searchValuePlotsDetailedStatement, setSearchValuePlotsDetailedStatement] = useState(''); // Search value
  //const [searchValuePlotsDetailed, setSearchValuePlotsDetailed] = useState('');

  const calculateTotalPlotsDetailedStatement = (rows) => {
    return rows.reduce((sum, row) => sum + parseFloat(row.amountPaid), 0).toFixed(2);
  };

  useEffect(() => {
    const formData = new FormData();
    formData.append('apiType', 'fetchPlotsDetailedStatement');
  

    const fetchDataPlotsDetailedStatement = async () => {
      try {
        const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
        const fetchedData = response.data.map((row, index) => ({
          sn: index + 1,
          businessLocationName: row.businessLocationName,
          name: `${row.customersLastName} ${row.customersFirstName}`,
          plotNumber: row.plotNumber,
          amountPaid: parseFloat(row.amountPaid),
          customersPhone: row.customersPhone,
          datePaid: row.datePaid,
          action: (
            <form action="plotsDetailedStatement.php" method="POST">
              <input type="hidden" name="email" value={row.customersEmail} />
              <button className="edit fa fa-eye green-text text-right" title="View"></button>
            </form>
          ),
        }));

        setDataPlotsDetailedStatement((prevState) => ({
          ...prevState,
          rows: fetchedData,
        }));

        setTotalAmountPlotsDetailedStatement(calculateTotalPlotsDetailedStatement(fetchedData));
        setFilteredDataPlotsDetailedStatement(fetchedData); // Initially set all data
      } catch (error) {
        alert('Internet Error: Failed to fetch data');
      }
    };

    fetchDataPlotsDetailedStatement();
  }, []);

  const handleTableSearch = (value) => {
    setSearchValuePlotsDetailedStatement(value);
    const filteredRows = dataPlotsDetailedStatement.rows.filter((row) => {
      return Object.values(row).some((field) => field.toString().toLowerCase().includes(value.toLowerCase()));
    });
    setFilteredDataPlotsDetailedStatement(filteredRows.slice(0, entriesPlotsDetailedStatement));
  };

  const exportPDFPlotsDetailedStatement = () => {
    const doc = new jsPDF('landscape');
    const pageSize = 100; 
    let pageData = [];
  const searchValueLower = searchValuePlotsDetailedStatement.trim().toLowerCase();

      const filteredByAllFields = searchValueLower === '' ? filteredDataPlotsDetailedStatement : filteredDataPlotsDetailedStatement.filter(row => 
          row.sn?.toString().toLowerCase().includes(searchValueLower) ||
          row.businessLocationName?.toString().toLowerCase().includes(searchValueLower) ||
          row.name?.toString().toLowerCase().includes(searchValueLower) ||
          row.plotNumber?.toString().toLowerCase().includes(searchValueLower) ||
          row.amountPaid.toString().toLowerCase().includes(searchValueLower) ||
          row.customersPhone?.toString().toLowerCase().includes(searchValueLower) ||
          row.datePaid?.toString().toLowerCase().includes(searchValueLower)
      );
    //for (let i = 0; i < filteredData.length; i += pageSize) {
      //pageData = filteredData.slice(i, i + pageSize);
      
      //for (let i = 0; i < filteredByAllFields.length; i += pageSize) {
      //pageData = filteredByAllFields.slice(i, i + pageSize);
      // Assuming calculateTotal is a function that takes an array of data and returns the total of the amountPaid field
const calculateTotalPlotsDetailedStatement = (data) => {
  return data.reduce((total, row) => total + parseFloat(row.amountPaid), 0);
};

 pageData = filteredByAllFields;

const calculatePageTotalPlotsDetailedStatement = (rows) => {
  return rows.reduce((total, row) => total + parseFloat(row.raw[4]), 0).toFixed(2);
};

const addPageTotalPlotsDetailedStatement = (data) => {
  let pageTotal = calculatePageTotalPlotsDetailedStatement(data.table.body);
  doc.text(`Total: K ${pageTotal}`, data.settings.margin.left + 350, doc.internal.pageSize.height - 10);
};

doc.autoTable({
  head: [['SN', 'Location', 'Name', 'Plot Number', 'Amount (ZMW)', 'Phone', 'Date Paid']],
  body: pageData.map((row, index) => [
    index + 1,
    row.businessLocationName,
    row.name,
    row.plotNumber,
    row.amountPaid.toFixed(2),
    row.customersPhone,
    row.datePaid
  ]),
  didDrawPage: addPageTotalPlotsDetailedStatement,
  margin: { bottom: 20 } // Adjust bottom margin to make space for the total text
});

const overallTotal = calculateTotalPlotsDetailedStatement(filteredByAllFields).toFixed(2);
doc.autoTable({
  head: [['', '', '', '', '', '', '']],
  foot: [['', '', '', 'Total:', overallTotal+"(ZMW)", '', '']],
  startY: doc.lastAutoTable.finalY + 10 // Start a bit after the last table
});


    doc.save('plots detailed statement.pdf');
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
  });

  const [housesData, setHousesData] = useState({
    columns: [
      { label: 'SN', field: 'sn' },
      { label: 'Location', field: 'businessLocationName' },
      { label: 'Name', field: 'name' },
      { label: 'Block', field: 'block' },
      { label: 'House Number', field: 'houseNumber' },
      { label: 'Amount', field: 'amountPaid' },
      { label: 'Gender', field: 'tenantGender' },
      { label: 'Phone', field: 'tenantPhone' },
      { label: 'Date', field: 'date' },
    ],
    rows: [],
  });

  const [housesTotalAmount, setHousesTotalAmount] = useState(0);
  const [housesFilteredData, setHousesFilteredData] = useState([]);
  const [housesEntries, setHousesEntries] = useState(5); // Number of entries per page
  const [housesSearchValue, setHousesSearchValue] = useState(''); // Search value

  const calculateTotalHousesDetailedStatement = (rows) => {
    return rows.reduce((sum, row) => sum + parseFloat(row.amountPaid), 0).toFixed(2);
  };
  useEffect(() => {
    const formDataHouses = new FormData();
    formDataHouses.append('apiType', 'fetchHousesDetailedStatement');
    const fetchHousesData = async () => {
      try {
        const response = await axios.post(`${server_app_api_php}/server/index.php`, formDataHouses);
        const fetchedData = response.data.map((row, index) => ({
          sn: index + 1,
          businessLocationName: row.businessLocationName,
          name: `${row.tenantFirstName} ${row.tenantLastName}`,
          block: row.block,
          houseNumber: row.houseNumber,
          amountPaid: parseFloat(row.amountPaid),
          tenantGender: row.tenantGender,
          tenantPhone: row.tenantPhone,
          date: `${row.monthPaid} - ${row.yearPaid}`,
        }));

        setHousesData((prevState) => ({
          ...prevState,
          rows: fetchedData,
        }));

        setHousesTotalAmount(calculateTotalHousesDetailedStatement(fetchedData));
        setHousesFilteredData(fetchedData); // Initially set all data
        //alert(response.data)
      } catch (error) {
       // alert('Internet Error: Failed to fetch Houses data');
      }
    };

    fetchHousesData();
  }, []);

  const handleTableSearchHouses = (value) => {
    setHousesSearchValue(value);
    const filteredRows = housesData.rows.filter((row) => {
      return Object.values(row).some((field) => field.toString().toLowerCase().includes(value.toLowerCase()));
    });
    setHousesFilteredData(filteredRows.slice(0, housesEntries));
  };

  const exportPDFHousesDetailedStatement = () => {
    const doc = new jsPDF('landscape');
    const pageSize = 5;
    let pageData = [];

    const searchValueLower = housesSearchValue.trim().toLowerCase();
    const filteredByAllFields = searchValueLower === '' ? housesFilteredData : housesFilteredData.filter(row => 
        row.sn?.toString().toLowerCase().includes(searchValueLower) ||
        row.businessLocationName?.toString().toLowerCase().includes(searchValueLower) ||
        row.name?.toString().toLowerCase().includes(searchValueLower) ||
        row.block?.toString().toLowerCase().includes(searchValueLower) ||
        row.plotNumber?.toString().toLowerCase().includes(searchValueLower) ||
        row.amountPaid.toString().toLowerCase().includes(searchValueLower) ||
        row.tenantPhone?.toString().toLowerCase().includes(searchValueLower) ||
        row.date?.toString().toLowerCase().includes(searchValueLower)
    );
    
    // Assuming calculateTotal is a function that takes an array of data and returns the total of the amountPaid field
const calculateTotalHousesDetailedStatement = (data) => {
return data.reduce((total, row) => total + parseFloat(row.amountPaid), 0);
};

pageData = filteredByAllFields;

const calculatePageTotalHousesDetailedStatement = (rows) => {
return rows.reduce((total, row) => total + parseFloat(row.raw[4]), 0).toFixed(2);
};

const addPageTotalHousesDetailedStatement = (data) => {
let pageTotal = calculatePageTotalHousesDetailedStatement(data.table.body);
doc.text(`Total: K ${pageTotal}`, data.settings.margin.left + 350, doc.internal.pageSize.height - 10);
};

    //for (let i = 0; i < housesFilteredData.length; i += pageSize) {
      //pageData = housesFilteredData.slice(i, i + pageSize);
      doc.autoTable({
        head: [['SN', 'Location', 'Name', 'Block', 'House Number', 'Amount (ZMW)', 'Phone', 'Date']],
        body: pageData.map((row, index) => [
          index + 1,
          row.businessLocationName,
          row.name,
          row.block,
          row.houseNumber,
          row.amountPaid.toFixed(2),
          row.tenantPhone,
          row.date
        ]),
        //foot: [['', '', '', 'Total: K', calculateTotalHousesDetailedStatement(pageData)]],
      });
    //}

    doc.autoTable({
      //body: [['', '', '', 'Overall Total: K', calculateTotalHousesDetailedStatement(housesFilteredData)]],
      foot: [['', '', '', '', 'Total: ', calculateTotalHousesDetailedStatement(pageData)+"(ZMW)", '', '']],
    });

    doc.save(`houses detailed statement.pdf`);
  };

  const componentRefHouses = useRef();
  const handlePrintHouses = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
  });

  const [plotsExpensesData, setPlotsExpensesData] = useState({
    columns: [
      { label: 'SN', field: 'sn' },
      { label: 'Location', field: 'businessLocationName' },
      { label: 'Expenses Amount', field: 'amount' },
      { label: 'Month Income', field: 'monthIncome' },
      { label: 'Balance', field: 'balance' },
      { label: 'Date', field: 'date' },
      {label: 'action', field: 'action'}
    ],
    rows: [],
  });

  const [plotsExpensesTotalAmount, setPlotsExpensesTotalAmount] = useState(0);
  const [plotsExpensesFilteredData, setPlotsExpensesFilteredData] = useState([]);
  const [plotsExpensesEntries, setPlotsExpensesEntries] = useState(5); // Number of entries per page
  const [plotsExpensesSearchValue, setPlotsExpensesSearchValue] = useState(''); // Search value

  const calculateTotalPlotsExpenses = (rows) => {
    return rows.reduce((sum, row) => sum + parseFloat(row.amount), 0).toFixed(2);
  };

  useEffect(() => {
    const formDataPlotsExpenses = new FormData();
    formDataPlotsExpenses.append('apiType', 'fetchPlotsBriefExpensesStatement');
    formDataPlotsExpenses.append('userCompanyID', window.userCompanyID)
    const fetchPlotsExpensesData = async () => {
      try {
        const response = await axios.post(`${server_app_api_php}/server/index.php`, formDataPlotsExpenses);
        const fetchedData = response.data.map((row, index) => ({
          sn: index + 1,
          businessLocationName: row.businessLocationName,
          amount: parseFloat(row.amountPlotsExpenses),
          monthIncome: row.amountPaidFromPlots,
          balance: row.balancePlotsExpenses,
          date: row.date,
          action: row.action
        }));

        setPlotsExpensesData((prevState) => ({
          ...prevState,
          rows: fetchedData,
        }));

        setPlotsExpensesTotalAmount(calculateTotalPlotsExpenses(fetchedData));
        setPlotsExpensesFilteredData(fetchedData); // Initially set all data
        //alert(response.data)
      } catch (error) {
        //alert('Internet Error: Failed to fetch Plots Brief Expenses data', error);
      }
    };

    fetchPlotsExpensesData();
  }, []);

  const handleTableSearchPlotsExpenses = (value) => {
    setPlotsExpensesSearchValue(value);
    const filteredRows = plotsExpensesData.rows.filter((row) => {
      return Object.values(row).some((field) => field.toString().toLowerCase().includes(value.toLowerCase()));
    });
    setPlotsExpensesFilteredData(filteredRows.slice(0, plotsExpensesEntries));
  };

  const exportPDFPlotsExpenses = () => {
    const doc = new jsPDF('landscape');
    const pageSize = 5;
    let pageData = [];

    
    const searchValueLower = plotsExpensesSearchValue.trim().toLowerCase();
    const filteredByAllFields = searchValueLower === '' ? plotsExpensesFilteredData : plotsExpensesFilteredData.filter(row => 
        row.sn?.toString().toLowerCase().includes(searchValueLower) ||
        row.businessLocationName?.toString().toLowerCase().includes(searchValueLower) ||
        row.amount?.toString().toLowerCase().includes(searchValueLower) ||
        row.monthIncome?.toString().toLowerCase().includes(searchValueLower) ||
        row.balance?.toString().toLowerCase().includes(searchValueLower) ||
        row.date?.toString().toLowerCase().includes(searchValueLower)
    );
    
    // Assuming calculateTotal is a function that takes an array of data and returns the total of the amountPaid field
const calculateTotalPlotsExpenses = (data) => {
return data.reduce((total, row) => total + parseFloat(row.amount), 0);
};

pageData = filteredByAllFields;

const calculatePageTotalPlotsExpenses = (rows) => {
return rows.reduce((total, row) => total + parseFloat(row.raw[4]), 0).toFixed(2);
};

const addPageTotalPlotsExpenses = (data) => {
let pageTotal = calculatePageTotalPlotsExpenses(data.table.body);
doc.text(`Total: K ${pageTotal}`, data.settings.margin.left + 350, doc.internal.pageSize.height - 10);
};

    //for (let i = 0; i < plotsExpensesFilteredData.length; i += pageSize) {
      //pageData = plotsExpensesFilteredData.slice(i, i + pageSize);
      doc.autoTable({
        head: [['SN', 'Location', 'Expenses Amount (ZMW)', 'Month Income (ZMW)', 'Balance (ZMW)', 'Date']],
        body: pageData.map((row, index ) => [
          index + 1,
          row.businessLocationName,
          row.amount.toFixed(2),
          row.monthIncome,
          row.balance,
          row.date
        ]),
        //foot: [['', '', '', 'Total: K', calculateTotalPlotsExpenses(pageData)]],
      });
    //}

    doc.autoTable({
      //body: [['', '', '', 'Overall Total: K', calculateTotalPlotsExpenses(plotsExpensesFilteredData)]],
      foot: [['', '', '', 'Total Expenses', calculateTotalPlotsExpenses(pageData)+"(ZMW)"]],
    });

    doc.save(`plots brief expenses statement.pdf`);
  };

  const componentRefPlotsExpenses = useRef();
  const handlePrintPlotsExpenses = useReactToPrint({
    content: () => componentRefPlotsExpenses.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
  });


  
  const [housesExpensesData, setHousesExpensesData] = useState({
    columns: [
      { label: 'SN', field: 'sn' },
      { label: 'Location', field: 'businessLocationName' },
      { label: 'Expenses Amount', field: 'amount' },
      { label: 'Month Income', field: 'monthIncome' },
      { label: 'Balance', field: 'balance' },
      { label: 'Date', field: 'date' },
      {label: 'action', field: 'action'}
    ],
    rows: [],
  });

  const [housesExpensesTotalAmount, setHousesExpensesTotalAmount] = useState(0);
  const [housesExpensesFilteredData, setHousesExpensesFilteredData] = useState([]);
  const [housesExpensesEntries, setHousesExpensesEntries] = useState(5); // Number of entries per page
  const [housesExpensesSearchValue, setHousesExpensesSearchValue] = useState(''); // Search value

  const calculateTotalHousesExpenses = (rows) => {
    return rows.reduce((sum, row) => sum + parseFloat(row.amount), 0).toFixed(2);
  };

  useEffect(() => {
   
   //alert(userCompanyID)
   userCompanyID = JSON.parse(userCompanyID)
   //alert(userCompanyID)
    const formDataHousesExpenses = new FormData();
    formDataHousesExpenses.append('apiType', 'fetchHousesBriefExpensesStatement');
    formDataHousesExpenses.append('userCompanyID', userCompanyID)
    const fetchHousesExpensesData = async () => {
      try {
        const response = await axios.post(`${server_app_api_php}/server/index.php`, formDataHousesExpenses);
        const fetchedData = response.data.map((row, index) => ({
          sn: index + 1,
          businessLocationName: row.businessLocationName,
          amount: parseFloat(row.amountHouses),
          monthIncome: row.amountPaidFromRentals,
          balance: row.balanceFromRentals,
          date: row.date,
          action: row.action
        }));

        setHousesExpensesData((prevState) => ({
          ...prevState,
          rows: fetchedData,
        }));

        setHousesExpensesTotalAmount(calculateTotalHousesExpenses(fetchedData));
        setHousesExpensesFilteredData(fetchedData); // Initially set all data
        //alert(response.data)
      } catch (error) {
        //alert('Internet Error: Failed to fetch Houses Brief Expenses data', error);
      }
    };

    fetchHousesExpensesData();
  }, []);

  const handleTableSearchHousesExpenses = (value) => {
    setHousesExpensesSearchValue(value);
    const filteredRows = housesExpensesData.rows.filter((row) => {
      return Object.values(row).some((field) => field.toString().toLowerCase().includes(value.toLowerCase()));
    });
    setHousesExpensesFilteredData(filteredRows.slice(0, housesExpensesEntries));
  };

  const exportPDFHousesExpenses = () => {
    const doc = new jsPDF('landscape');
    const pageSize = 5;
    let pageData = [];
      
    const searchValueLower = housesExpensesSearchValue.trim().toLowerCase();
    const filteredByAllFields = searchValueLower === '' ? housesExpensesFilteredData : housesExpensesFilteredData.filter(row => 
        row.sn?.toString().toLowerCase().includes(searchValueLower) ||
        row.businessLocationName?.toString().toLowerCase().includes(searchValueLower) ||
        row.amount?.toString().toLowerCase().includes(searchValueLower) ||
        row.monthIncome?.toString().toLowerCase().includes(searchValueLower) ||
        row.balance?.toString().toLowerCase().includes(searchValueLower) ||
        row.date?.toString().toLowerCase().includes(searchValueLower)
    );
    
    // Assuming calculateTotal is a function that takes an array of data and returns the total of the amountPaid field
const calculateTotalHousesExpenses = (data) => {
return data.reduce((total, row) => total + parseFloat(row.amount), 0);
};

pageData = filteredByAllFields;

const calculatePageTotalPlotsExpenses = (rows) => {
return rows.reduce((total, row) => total + parseFloat(row.raw[4]), 0).toFixed(2);
};

const addPageTotalPlotsExpenses = (data) => {
let pageTotal = calculatePageTotalPlotsExpenses(data.table.body);
doc.text(`Total: K ${pageTotal}`, data.settings.margin.left + 350, doc.internal.pageSize.height - 10);
};
    //for (let i = 0; i < housesExpensesFilteredData.length; i += pageSize) {
      //pageData = housesExpensesFilteredData.slice(i, i + pageSize);
      doc.autoTable({
        head: [['SN', 'Location', 'Expenses Amount (ZMW)', 'Month Income (ZMW)', 'Balance (ZMW)', 'Date']],
        body: pageData.map((row, index ) => [
          index + 1,
          row.businessLocationName,
          row.amount.toFixed(2),
          row.monthIncome,
          row.balance,
          row.date
        ]),
        //foot: [['', '', '', 'Total: K', calculateTotalHousesExpenses(pageData)]],
      });
    //}

    doc.autoTable({
      //body: [['', '', '', 'Overall Total: ', calculateTotalHousesExpenses(housesExpensesFilteredData)]],
      foot: [['', '', '', 'Total Expenses ', calculateTotalHousesExpenses(pageData)+"(ZMW)"]],
    });

    doc.save(`houses brief expenses statement.pdf`);
  };

  const componentRefHousesExpenses = useRef();
  const handlePrintHousesExpenses = useReactToPrint({
    content: () => componentRefHousesExpenses.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
  });


  /**********Codes for DataTables Starts Here************/

  /**********Codes for DataTables Of Plots Detailed StatemnetStarts Here************/
   
  const [DBtablePlotsDetailedStatement, setDBtablePlotsDetailedStatement] = useState([]);
  //const [pdfData, setPdfData] = useState([]);
  const [entriesValuePlotsDetailedStatement, setEntriesValuePlotsDetailedStatement] = useState(5);
  useEffect(() => {
    fetchDataForTablePlotsDetailedStatement();
  }, [entriesValuePlotsDetailedStatement]);


  const fetchDataForTablePlotsDetailedStatement = async () => {
    const formData = new FormData();
    formData.append('apiType', 'fetchPlotsDetailedStatement');
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
      //alert('API Response Data for Table: ' + JSON.stringify(response.data));

      const processedData = response.data.map(row => ({
        ...row,
        amountPaid: parseFloat(row.amountPaid) || 0
      }));

      setDBtablePlotsDetailedStatement(processedData);
      //alert('Processed Data for Table: ' + JSON.stringify(processedData));

      setTimeout(() => {
        const table = $('#table').DataTable({
          footerCallback: function (row, data, start, end, display) {
            const api = this.api();

            const pageTotal = api
              .column(4, { page: 'current' })
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            //alert('Page Total: ' + pageTotal);

            $(api.column(4).footer()).html(pageTotal.toFixed(2));

            const overallTotal = api
              .column(4)
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            //alert('Overall Total: ' + overallTotal);

            $('#totalOverallPlotsDetailedStatement').html(overallTotal.toFixed(2));
          },
          retrieve: true,
          pageLength: entriesValuePlotsDetailedStatement,
          lengthMenu: [5, 10, 25, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 15000, 20000, 50000, 100000, 500000, 1000000],
          initComplete: function () {
            const api = this.api();
            setSearchValuePlotsDetailedStatement(api.search());
            setEntriesValuePlotsDetailedStatement(api.page.len());

            api.on('search.dt', function () {
              setSearchValuePlotsDetailedStatement(api.search());
            });

            api.on('length.dt', function () {
              setEntriesValuePlotsDetailedStatement(api.page.len());
            });
          }
        });

        //addTableButtons(table);
      }, 1000);
    } catch (error) {
      //alert('Error fetching data for table: ' + error);
    }
  };
 /**********Codes For DataTables Of Plots Detailed Statemnet Ends Here****************/

 
  /**********Codes for DataTables Of Houses Detailed Statemnet Starts Here************/
   
  const [DBtableHousesDetailedStatement, setDBtableHousesDetailedStatement] = useState([]);
  //const [pdfData, setPdfData] = useState([]);
  const [entriesValueHousesDetailedStatement, setEntriesValueHousesDetailedStatement] = useState(5);
  useEffect(() => {
    fetchDataForTableHousesDetailedStatement();
  }, [entriesValueHousesDetailedStatement]);


  const fetchDataForTableHousesDetailedStatement = async () => {
    const formData = new FormData();
    formData.append('apiType', 'fetchHousesDetailedStatement');
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
      //alert('API Response Data for Table: ' + JSON.stringify(response.data));

      const processedData = response.data.map(row => ({
        ...row,
        amountPaid: parseFloat(row.amountPaid) || 0
      }));

      setDBtableHousesDetailedStatement(processedData);
      //alert(processedData)
      //alert('Processed Data for Table: ' + JSON.stringify(processedData));

      setTimeout(() => {
        const table = $('#tableHousesDetailedStatement').DataTable({
          footerCallback: function (row, data, start, end, display) {
            const api = this.api();

            const pageTotal = api
              .column(5, { page: 'current' })
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            //alert('Page Total: ' + pageTotal);

            $(api.column(5).footer()).html(pageTotal.toFixed(2));

            const overallTotalHousesDetailedStatement = api
              .column(5)
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            //alert('Overall Total: ' + overallTotal);

            $('#totalOverallHousesDetailedStatement').html(overallTotalHousesDetailedStatement.toFixed(2));
          },
          retrieve: true,
          pageLength: entriesValueHousesDetailedStatement,
          lengthMenu: [5, 10, 25, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 15000, 20000, 50000, 100000, 500000, 1000000],
          initComplete: function () {
            const api = this.api();
            setHousesSearchValue(api.search());
            setEntriesValueHousesDetailedStatement(api.page.len());

            api.on('search.dt', function () {
              setHousesSearchValue(api.search());
            });

            api.on('length.dt', function () {
              setEntriesValueHousesDetailedStatement(api.page.len());
            });
          }
        });

        //addTableButtons(table);
      }, 1000);
    } catch (error) {
      //alert('Error fetching data for table: ' + error);
    }
  };
 /**********Codes For DataTables Of Houses Detailed Statemnet Ends Here****************/
 
 /**********Codes for DataTables Of Plots Expenses Report Starts Here************/
   
 const [DBtablePlotsExpenses, setDBtablePlotsExpenses] = useState([]);
 //const [pdfData, setPdfData] = useState([]);
 const [entriesValuePlotsExpenses, setEntriesValuePlotsExpenses] = useState(5);
 useEffect(() => {
   fetchDataForTablePlotsExpenses();
 }, [entriesValuePlotsExpenses]);


 const fetchDataForTablePlotsExpenses = async () => {
  /*
   let userCompanyID = localStorage.getItem('companyID')
   if(userCompanyID === 'Admin'){
    userCompanyID = 1;
   }
   //alert(userCompanyID)
   userCompanyID = JSON.parse(userCompanyID)
   //alert(userCompanyID)
    const formDataPlotsExpenses = new FormData();
    formDataPlotsExpenses.append('apiType', 'fetchPlotsBriefExpensesStatement');
    formDataPlotsExpenses.append('userCompanyID', userCompanyID)
  */
   
   const formData = new FormData();
   formData.append('apiType', 'fetchPlotsBriefExpensesStatement');
   formData.append('userCompanyID', userCompanyID)
   try {
     const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
     //alert('API Response Data for Table: ' + JSON.stringify(response.data));

     const processedData = response.data.map(row => ({
       ...row,
       amountPaid: parseFloat(row.amountPaid) || 0
     }));

     setDBtablePlotsExpenses(processedData);
     //alert(processedData)
     //alert('Processed Data for Table: ' + JSON.stringify(processedData));

     setTimeout(() => {
       const table = $('#tablePlotsExpenses').DataTable({
         footerCallback: function (row, data, start, end, display) {
           const api = this.api();

           const pageTotal = api
             .column(2, { page: 'current' })
             .data()
             .reduce((a, b) => a + (parseFloat(b) || 0), 0);

           //alert('Page Total: ' + pageTotal);

           $(api.column(2).footer()).html(pageTotal.toFixed(2));

           const overallTotalPlotsExpenses = api
             .column(2)
             .data()
             .reduce((a, b) => a + (parseFloat(b) || 0), 0);

           //alert('Overall Total: ' + overallTotal);

           $('#totalOverallPlotsExpenses').html(overallTotalPlotsExpenses.toFixed(2));
         },
         retrieve: true,
         pageLength: entriesValuePlotsExpenses,
         lengthMenu: [5, 10, 25, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 15000, 20000, 50000, 100000, 500000, 1000000],
         initComplete: function () {
           const api = this.api();
           setPlotsExpensesSearchValue(api.search());
           setPlotsExpensesEntries(api.page.len());

           api.on('search.dt', function () {
            setPlotsExpensesSearchValue(api.search());
           });

           api.on('length.dt', function () {
            setPlotsExpensesEntries(api.page.len());
           });
         }
       });

       //addTableButtons(table);
     }, 1000);
   } catch (error) {
     //alert('Error fetching data for table: ' + error);
   }
 };
/**********Codes For DataTables Of Plots Expenses Report Ends Here****************/

 /**********Codes for DataTables Of Houses Expenses Report Starts Here************/
   
 const [DBtableHousesExpenses, setDBtableHousesExpenses] = useState([]);
 //const [pdfData, setPdfData] = useState([]);
 const [entriesValueHousesExpenses, setEntriesValueHousesExpenses] = useState(5);
 useEffect(() => {
   fetchDataForTableHousesExpenses();
 }, [entriesValueHousesExpenses]);


 const fetchDataForTableHousesExpenses = async () => {

  

   const formData = new FormData();
   formData.append('apiType', 'fetchHousesBriefExpensesStatement');
   formData.append('userCompanyID', userCompanyID)
   try {
     const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
     //alert('API Response Data for Table: ' + JSON.stringify(response.data));

     const processedData = response.data.map(row => ({
       ...row,
       amountPaid: parseFloat(row.amountPaid) || 0
     }));

     setDBtableHousesExpenses(processedData);
     //alert(processedData)
     //alert('Processed Data for Table: ' + JSON.stringify(processedData));

     setTimeout(() => {
       const table = $('#tableHousesExpenses').DataTable({
         footerCallback: function (row, data, start, end, display) {
           const api = this.api();

           const pageTotal = api
             .column(2, { page: 'current' })
             .data()
             .reduce((a, b) => a + (parseFloat(b) || 0), 0);

           //alert('Page Total: ' + pageTotal);

           $(api.column(2).footer()).html(pageTotal.toFixed(2));

           const overallTotalHousesExpenses = api
             .column(2)
             .data()
             .reduce((a, b) => a + (parseFloat(b) || 0), 0);

           //alert('Overall Total: ' + overallTotal);

           $('#totalOverallHousesExpenses').html(overallTotalHousesExpenses.toFixed(2));
         },
         retrieve: true,
         pageLength: entriesValueHousesExpenses,
         lengthMenu: [5, 10, 25, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 15000, 20000, 50000, 100000, 500000, 1000000],
         initComplete: function () {
           const api = this.api();
           setHousesExpensesSearchValue(api.search());
           setHousesExpensesEntries(api.page.len());

           api.on('search.dt', function () {
            setHousesExpensesSearchValue(api.search());
           });

           api.on('length.dt', function () {
            setHousesExpensesEntries(api.page.len());
           });
         }
       });

       //addTableButtons(table);
     }, 1000);
   } catch (error) {
    // alert('Error fetching data for table: ' + error);
   }
 };
/**********Codes For DataTables Of Houses Expenses Report Ends Here****************/

 /**********Codes For DataTables Ends Here****************/


  /**********Codes for DataTables Of Plots Customer Starts Here************/
  const [customerStatement, setCustomerStatement] = useState([{ loopedItems: [], nonLoopedItems: {} }]); 
  const [DBtablePlotCustomerStatement, setDBtablePlotCustomerStatement] = useState([]);
  const [entriesValuePlotCustomerStatement, setEntriesValuePlotCustomerStatement] = useState(5);
  const [searchValuePlotCustomerStatement, setSearchValuePlotCustomerStatement] = useState('');
  const [plotCustomerStatementcustomerID, setPlotCustomerStatementcustomerID] = useState([]);
  useEffect(() => {
if(userType=== 'Customer'){
    fetchDataForTablePlotCustomerStatement();
  }
  }, [entriesValuePlotCustomerStatement]);

  const fetchDataForTablePlotCustomerStatement = async () => {
    const formData = new FormData();
    formData.append('apiType', 'getPlotCustomer');
    formData.append('userEmail', userEmail);
    //alert(userEmail)
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
   setDBtablePlotCustomerStatement(response.data);
   setPlotCustomerStatementcustomerID(response.data.customerStatement);
   //setCustomerStatement(response.data);
   //console.log('Customer Statement', response.data)
   //const loopedItems = response.data.customerStatement.map(item => item.loopedItems).flat() || [];
   //const nonLoopedItems = response.data.customerStatement.map(item => item.nonLoopedItems) || [];
   //setCustomerStatement({ loopedItems, nonLoopedItems });
   console.log('Full Response', response.data);
   if (response.data && response.data.length > 0) {
       response.data.forEach(item => {
           if (item.customerStatement) {
               console.log('Customer Statement', item.customerStatement);
               const loopedItems = item.customerStatement.flatMap(statement => statement.loopedItems) || [];
               const nonLoopedItems = item.customerStatement.map(statement => statement.nonLoopedItems) || [];
               setCustomerStatement({ loopedItems, nonLoopedItems });
               console.log('Looped Items', loopedItems);
               console.log('Non-Looped Items', nonLoopedItems);

           } else {
               console.error('Customer Statement is undefined for item', item);
           }
       });
   } else {
       //console.error('Response data is empty or undefined');
   }

   
      setTimeout(() => {
        const table = $('#tablePlotCustomerStatement').DataTable({
          footerCallback: function (row, data, start, end, display) {
            const api = this.api();

            const pageTotal = api
              .column(2, { page: 'current' })
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            $(api.column(2).footer()).html(pageTotal.toFixed(2));

            const overallTotal = api
              .column(2)
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);
              
            $('#totalOverallPlotCustomerStatement').html(overallTotal.toFixed(2));
          },
          retrieve: true,
          pageLength: entriesValuePlotCustomerStatement,
          lengthMenu: [5, 10, 25, 50, 100, 200],
          initComplete: function () {
            const api = this.api();
            setSearchValuePlotCustomerStatement(api.search());
            setEntriesValuePlotCustomerStatement(api.page.len());

            api.on('search.dt', function () {
              setSearchValuePlotCustomerStatement(api.search());
            });
            api.on('length.dt', function () {
              setEntriesValuePlotCustomerStatement(api.page.len());
            });
          }
        });
        //addTableButtons(table);
      }, 1000);
    } catch (error) {
      //alert('Error fetching data for table: ' + error);
    }
  };
  /**********Codes For DataTables Of Plots Customer Ends Here****************/

    //**************Function To Respond To View Statement From The Main Table Ends Here***********************
  const { loopedItems, nonLoopedItems } = customerStatement;

 // Ensure nonLoopedItems is defined and is an array
const groupByPlotNumber = (items) => {
  if (!Array.isArray(items)) {
    return {}; // Return an empty object if items is not an array
  }
  return items.reduce((acc, item) => {
    const { plotNumber } = item;
    if (!acc[plotNumber]) {
      acc[plotNumber] = [];
    }
    acc[plotNumber].push(item);
    return acc;
  }, {});
};
// Safely access nonLoopedItems
const groupedItems = groupByPlotNumber(nonLoopedItems || []);

/**************** Plots Customers PDF Generating Function Code Starts Here ******************/
const generatePDFPlotCustomerStatement = (nonLoopedItems, groupedItems, logo, loopedItems, action) => {
  //alert(action);
  const doc = new jsPDF('landscape'); // Create PDF in landscape orientation
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  
  // Add logo
  if (logo) {
    const img = new Image();
    img.src = logo;
    doc.addImage(img, 'PNG', 135, 7, 30, 15); // Position the image in the center
  }
  
  // Title with styling
  doc.setFontSize(18);
  doc.setTextColor(0, 0, 0); // Black text
  doc.text('Customer Statement', pageWidth / 2, 30, { align: 'center' });
  
  // Customer Details section with background color and text color
  doc.setFillColor(0, 105, 148); // Deep Ocean Blue
  doc.rect(10, 40, 270, 20, 'F'); // Filled rectangle for background
  
  doc.setFontSize(12);
  doc.setTextColor(255, 255, 255); // White text
  if (Array.isArray(nonLoopedItems) && nonLoopedItems.length > 0) {
    doc.text(`Name: ${nonLoopedItems[0]?.name || '-'}`, 12, 50);
    doc.text(`Phone: ${nonLoopedItems[0]?.customersPhone || '-'}`, 100, 50);
    doc.text(`Email: ${nonLoopedItems[0]?.customersEmail || '-'}`, 170, 50);
  } else {
    doc.text('No items available.', 12, 50);
  }
  
  // Add a line break
  doc.setLineWidth(0.5);
  doc.line(10, 65, 280, 65); // Horizontal line
  
  // Grouped Items
  let startY = 75;
  const marginBottom = 20; // Space at the bottom of the page
  
  Object.keys(groupedItems).forEach((plotNumber, index) => {
    const item = groupedItems[plotNumber][0];
    let blockHeight = 75;
    if (item?.paidToNHEF) { 
     blockHeight = 75; // Approximate height needed for each block of content
    }
    else{
       blockHeight = 65; // Approximate height needed for each block of content
    }
    // Check if the current block will overflow the page
    if (startY + blockHeight > pageHeight - marginBottom) {
      doc.addPage(); // Add a new page if needed
      startY = 20; // Reset the starting Y position for the new page
    }
  
    // Background for each group
    doc.setFillColor(0, 105, 148); // Deep Ocean Blue
    doc.rect(10, startY, 270, blockHeight - 10, 'F'); // Filled rectangle for background
  
    doc.setFontSize(12);
    doc.setTextColor(255, 255, 255); // White text
    doc.text(`Location: ${item?.businessLocationName || '-'}`, 12, startY + 10);
    doc.text(`Plot Number: ${plotNumber || '-'}`, 12, startY + 20);
    doc.text(`Plot Area: ${item?.plotArea + " (M2)" || '-'}`, 12, startY + 30);
    doc.text(`Amount Contributed: ${formatCurrency(item?.totalAmountPaid) + " (ZMW)" || '-'}`, 12, startY + 40);
    if (item?.paidToNHEF) {      
      doc.text(`Paid To NHEF: ${formatCurrency(item?.paidToNHEF) + " (ZMW)" || '-'}`, 12, startY + 50);
      doc.text(`Total Contributions: ${formatCurrency(item?.totalContributions) + " (ZMW)" || '-'}`, 12, startY + 60);
    }
    else{
      doc.text(`Total Contributions: ${formatCurrency(item?.totalContributions) + " (ZMW)" || '-'}`, 12, startY + 50);
    }
  
    
    doc.text(`Plot Price: ${formatCurrency(item?.plotPrice) + " (ZMW)" || '-'}`, 180, startY + 10);
    doc.text(`Balance: ${formatCurrency(item?.balance) + " (ZMW)" || '-'}`, 180, startY + 20);
    doc.text(`Monthly Installments: ${formatCurrency(item?.monthlyInstallments) + " (ZMW)" || '-'}`, 180, startY + 30);
    doc.text(`Last Date Paid: ${item?.lastDatePaid || '-'}`, 180, startY + 40);
    doc.text(`Date Contract Signed: ${item?.dateContractSigned || '-'}`, 180, startY + 50);
  
    // Update the startY for the next block of content
    startY += blockHeight;
  });
  
  // Add space before the table
  startY += 20;
  
  // Check if the table will fit on the remaining space of the page
  if (startY + 20 > pageHeight - marginBottom) {
    doc.addPage(); // Add a new page if needed
    startY = 20;
  }
  
  // Table content
  const tableData = loopedItems.map((val, index) => [
    index + 1,
    val.plotNumber,
    formatCurrencyTable(val.amountPaid),
    val.datePaid,
  ]);
  
  // Generate the table
  doc.autoTable({
    startY, // Start position of the table
    head: [['SN', 'Plot Number', 'Amount (ZMW)', 'Date']],
    body: tableData,
    theme: 'striped',
    headStyles: {
      fillColor: [0, 128, 255], // Ocean blue gradient for header
      textColor: [255, 255, 255], // White text
    },
    styles: {
      cellPadding: 3,
      fontSize: 10,
    },
  });
  
  // Add page numbers before saving
  addPageNumber(doc);
  
  // Save the PDF
  //doc.save('CustomerStatement.pdf');
  

  if (action === "Download") {
    doc.save('Customer Statement.pdf');
  } 
  else if (action === "Email") {
// Return the PDF as a Blob
  //return doc.output('blob');
  // Convert PDF to Blob
  const pdfOutput = doc.output('blob');
    
  // Create FormData to send to the server
  const formData = new FormData();
  formData.append('file', pdfOutput, 'Customer Statement.pdf');
  formData.append('apiType', 'sendEmailCustomerStatementPDF');
  formData.append('email', userEmail);

  // Send the PDF to your server
  axios.post(`${server_app_api_php}/server/index.php`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  .then(response => {
    alert('Email sent successfully', response.data);
  })
  .catch(error => {
    alert('Error sending email');
  });
  }
};
// Function to add page numbers
const addPageNumber = (doc) => {
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(10);
    doc.setTextColor(128, 128, 128); // Gray text
    doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.getWidth() - 20, doc.internal.pageSize.getHeight() - 10, { align: 'right' });
  }
};
/******************* Plots Customers PDF Generating Function Code Starts Here ******************************/

  /**********Codes for DataTables Of Plots Customer Starts Here************/
  const [tenantStatement, setTenantStatement] = useState([{ loopedItems: [], nonLoopedItems: {} }]); 
  const [DBtableHouseTenantStatement, setDBtableHouseTenantStatement] = useState([]);
  const [entriesValueHouseTenantStatement, setEntriesValueHouseTenantStatement] = useState(5);
  const [searchValueHouseTenantStatement, setSearchValueHouseTenantStatement] = useState('');
  const [houseTenantStatementTenantID, setHouseTenantStatementTenantID] = useState([]);
  useEffect(() => {
if(userType=== 'Tenant'){
    fetchDataForTableHouseTenantStatement();
  }
  }, [entriesValueHouseTenantStatement]);

  const fetchDataForTableHouseTenantStatement = async () => {
    const formData = new FormData();
    formData.append('apiType', 'getHouseTenant');
    formData.append('userEmail', userEmail);
    //alert(userEmail)
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
   setDBtableHouseTenantStatement(response.data);
   setHouseTenantStatementTenantID(response.data.tenantStatement);
   console.log('Full Response', response.data);
   if (response.data && response.data.length > 0) {
       response.data.forEach(item => {
           if (item.tenantStatement) {
               console.log('Tenant Statement', item.tenantStatement);
               const loopedItemsHouses = item.tenantStatement.flatMap(statement => statement.loopedItems) || [];
               const nonLoopedItemsHouses = item.tenantStatement.map(statement => statement.nonLoopedItems) || [];
               setTenantStatement({ loopedItemsHouses, nonLoopedItemsHouses });
               console.log('Looped Items Houses', loopedItemsHouses);
               console.log('Non-Looped Items Houses', nonLoopedItemsHouses);

           } else {
               //console.error('Tenant Statement is undefined for item', item);
           }
       });
   } else {
       //console.error('Response data is empty or undefined - Houses');
   }

   
      setTimeout(() => {
        const table = $('#tableHouseTenantStatement').DataTable({
          footerCallback: function (row, data, start, end, display) {
            const api = this.api();

            const pageTotal = api
              .column(1, { page: 'current' })
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            $(api.column(1).footer()).html(pageTotal.toFixed(1));

            const overallTotal = api
              .column(1)
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);
              
            $('#totalOverallHouseTenantStatement').html(overallTotal.toFixed(2));
          },
          retrieve: true,
          pageLength: entriesValueHouseTenantStatement,
          lengthMenu: [5, 10, 25, 50, 100, 200],
          initComplete: function () {
            const api = this.api();
            setSearchValueHouseTenantStatement(api.search());
            setEntriesValueHouseTenantStatement(api.page.len());

            api.on('search.dt', function () {
              setSearchValueHouseTenantStatement(api.search());
            });
            api.on('length.dt', function () {
              setEntriesValueHouseTenantStatement(api.page.len());
            });
          }
        });
        //addTableButtons(table);
      }, 1000);
    } catch (error) {
      //alert('Error fetching data for table: ' + error);
    }
  };
  /**********Codes For DataTables Of Houses Tenants Ends Here****************/

    //**************Function To Respond To View Statement From The Main Table Ends Here***********************
  const { loopedItemsHouses, nonLoopedItemsHouses } = tenantStatement;

/**************** Houses Tenants PDF Generating Function Code Starts Here ******************/
const generatePDFHouseTenantStatement = (nonLoopedItemsHouses, logo, loopedItemsHouses, action) => {
  //alert(action);
  const doc = new jsPDF('landscape'); // Create PDF in landscape orientation
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Add logo
  if (logo) {
    const img = new Image();
    img.src = logo;
    doc.addImage(img, 'PNG', 135, 7, 30, 15); // Position the image in the center
  }
  // Title with styling
  doc.setFontSize(18);
  doc.setTextColor(0, 0, 0); // Black text
  doc.text('Tenant Statement', doc.internal.pageSize.getWidth() / 2, 30, { align: 'center' });

  // Customer Details section with background color and text color
  //doc.setFillColor(41, 182, 246); // Light blue background
  doc.setFillColor(0, 105, 148); // Deep Ocean Blue
  doc.rect(10, 40, 270, 20, 'F'); // Filled rectangle for background

  doc.setFontSize(12);
  doc.setTextColor(255, 255, 255); // White text
  if (Array.isArray(nonLoopedItemsHouses) && nonLoopedItemsHouses.length > 0) {
    doc.text(`Name: ${nonLoopedItemsHouses[0]?.name || '-'}`, 12, 50);
    doc.text(`Phone: ${nonLoopedItemsHouses[0]?.tenantPhone || '-'}`, 100, 50);
    doc.text(`Email: ${nonLoopedItemsHouses[0]?.tenantEmail || '-'}`, 170, 50);
  } else {
    doc.text('No items available.', 12, 50);
  }

  // Add a line break
  doc.setLineWidth(0.5);
  doc.line(10, 65, 280, 65); // Horizontal line

  // Grouped Items
  let startY = 75;
  //Object.keys(nonLoopedItemsHouses).forEach((plotNumber, index) => {
    //const item = groupedItems[plotNumber][0];
    //const yPosition = startY + index * 50; // Adjust Y position based on index
    const yPosition = startY + 0 * 50; // Adjust Y position based on index

    // Background for each group
    //doc.setFillColor(41, 182, 246); // Light blue background
    doc.setFillColor(0, 105, 148); // Deep Ocean Blue
    doc.rect(10, yPosition, 270, 45, 'F'); // Filled rectangle for background

     doc.setFontSize(12);
    doc.setTextColor(255, 255, 255); // White text
    doc.text(`Location: ${nonLoopedItemsHouses[0]?.businessLocationName || '-'}`, 12, yPosition + 10);
    doc.text(`House Number: ${nonLoopedItemsHouses[0]?.houseNumber || '-'}`, 12, yPosition + 20);
    doc.text(`Block: ${nonLoopedItemsHouses[0]?.block || '-'}`, 12, yPosition + 30);
    doc.text(`Total Amount Paid: ${formatCurrency(nonLoopedItemsHouses[0]?.rentalsTotalAmountPaid) + " (ZMW)" || '-'}`, 12, yPosition + 40);

    doc.text(`Rental Price: ${formatCurrency(nonLoopedItemsHouses[0]?.rentalPrice) + " (ZMW)" || '-'}`, 180, yPosition + 10);
    doc.text(`Balance: ${formatCurrency(nonLoopedItemsHouses[0]?.balance) + " (ZMW)" || '-'}`, 180, yPosition + 20);
    doc.text(`Last Date Paid: ${nonLoopedItemsHouses[0]?.lastDatePaid || '-'}`, 180, yPosition + 30);
    doc.text(`Date Contract Signed: ${nonLoopedItemsHouses[0]?.dateContractSigned || '-'}`, 180, yPosition + 40);

    // Add a line break between grouped items
    doc.setLineWidth(0.2);
    doc.line(10, yPosition + 55, 280, yPosition + 55); // Horizontal line
 //});

  // Add space before the table
  //startY += Object.keys(nonLoopedItemsHouses).length * 50 + 20;

  // Table content
  const tableData = loopedItemsHouses.map((val, index) => [
    index + 1,
    formatCurrencyTable(val.amountPaid),
    val.datePaid,
  ]);

  // Generate the table
  doc.autoTable({
    //startY, // Start position of the table
    startY: 150,
    head: [['SN', 'Amount (ZMW)', 'Date']],
    body: tableData,
    theme: 'striped',
    headStyles: {
      fillColor: [0, 128, 255], // Ocean blue gradient for header
      textColor: [255, 255, 255], // White text
    },
    styles: {
      cellPadding: 3,
      fontSize: 10,
    },
    
          
  });

   // Add page numbers before saving
   addPageNumberHouses(doc);
  // Save the PDF
 // doc.save('CustomerStatement.pdf');

  if (action === "Download") {
    doc.save('Tenant Statement.pdf');
  } 
  else if (action === "Email") {
// Return the PDF as a Blob
  //return doc.output('blob');
  // Convert PDF to Blob
  const pdfOutput = doc.output('blob');
    
  // Create FormData to send to the server
  const formData = new FormData();
  formData.append('file', pdfOutput, 'Tenant Statement.pdf');
  formData.append('apiType', 'sendEmailCustomerStatementPDF');
  formData.append('email', userEmail);

  // Send the PDF to your server
  axios.post(`${server_app_api_php}/server/index.php`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  .then(response => {
    alert('Email sent successfully', response.data);
  })
  .catch(error => {
    alert('Error sending email');
  });
  }
};
// Function to add page numbers
const addPageNumberHouses = (doc) => {
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(10);
    doc.setTextColor(128, 128, 128); // Gray text
    doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.getWidth() - 20, doc.internal.pageSize.getHeight() - 10, { align: 'right' });
  }
};
/******************* Houses Tenants PDF Generating Function Code Starts Here ******************************/

const[business_locationIDGenerateIncomeStatementHouses, setBusiness_locationIDGenerateIncomeStatementHouses] = useState('');
const[startDateGenerateIncomeStatementHouses, setStartDateGenerateIncomeStatementHouses] = useState('');
const[endDateGenerateIncomeStatementHouses, setEndDateGenerateIncomeStatementHouses] = useState('');

const[business_locationIDGenerateIncomeStatementPlots, setBusiness_locationIDGenerateIncomeStatementPlots] = useState('');
const[startDateGenerateIncomeStatementPlots, setStartDateGenerateIncomeStatementPlots] = useState('');
const[endDateGenerateIncomeStatementPlots, setEndDateGenerateIncomeStatementPlots] = useState('');

const generateIncomeStatement = (type) => {
  console.log('Type', type)
  //alert(business_locationIDGenerateIncomeStatementHouses);
//const generateIncomeStatementHouses = async () => {
  // Create formData object
  const formData = new FormData();
  formData.append("apiType", 'generateIncomeStatement');
  //formData.append("userID", userIDGenerateIncomeStatementHouses);
  formData.append("companyID", userCompanyID);
  if(type === 'Houses'){
formData.append("startDate", startDateGenerateIncomeStatementHouses);
formData.append("endDate", endDateGenerateIncomeStatementHouses);
formData.append("location", business_locationIDGenerateIncomeStatementHouses);

console.log("startDate Houses", startDateGenerateIncomeStatementHouses);
console.log("endDate Houses", endDateGenerateIncomeStatementHouses);
console.log("location Houses", business_locationIDGenerateIncomeStatementHouses);

  }
  else{
    formData.append("startDate", startDateGenerateIncomeStatementPlots);
    formData.append("endDate", endDateGenerateIncomeStatementPlots);
    formData.append("location", business_locationIDGenerateIncomeStatementPlots);
    
    console.log("startDate Plots", startDateGenerateIncomeStatementPlots);
    console.log("endDate Plots", endDateGenerateIncomeStatementPlots);
    console.log("location Plots", business_locationIDGenerateIncomeStatementPlots);
    
      }
  // Fetch plot options from the backend using POST method
  axios.post(`${server_app_api_php}/server/index.php`, formData)
    .then(response => {
      //setBusinessLocationsHouses(response.data);
const data = response.data;

//console.log("userID", userIDGenerateIncomeStatementHouses);
console.log("companyID", userCompanyID);
console.log("startDate", startDateGenerateIncomeStatementHouses);
console.log("endDate", endDateGenerateIncomeStatementHouses);
console.log("location", business_locationIDGenerateIncomeStatementHouses);

//console.log('Data', data);

    const doc = new jsPDF();

    // Set document title
    doc.setFontSize(18);
    doc.text('Income Statement', 105, 20, null, null, 'center');

    // Add date range
    const dateRange = `${startDateGenerateIncomeStatementHouses} To ${endDateGenerateIncomeStatementHouses}`;
    doc.setFontSize(12);
    doc.text(`Period: ${dateRange}`, 105, 30, null, null, 'center');

    // Prepare the table
    const tableBody = [];
    
    // Add income and expenses
    tableBody.push(['INCOME', data.income]);
    tableBody.push(['COST OF SALES', '0']);
    tableBody.push(['GROSS PROFIT', data.income]);

    tableBody.push([{ content: 'EXPENSES - PLOTS', colSpan: 2, styles: { fontStyle: 'bold' } }]);
    data.expensesPlots.forEach(expense => {
      tableBody.push([expense.name, expense.amount]);
    });

    tableBody.push([{ content: 'EXPENSES - RENTALS', colSpan: 2, styles: { fontStyle: 'bold' } }]);
    data.expensesHouses.forEach(expense => {
      tableBody.push([expense.name, expense.amount]);
    });

    const netProfitLabel = data.netProfit < 0 ? 'NET LOSS' : 'NET PROFIT';
    tableBody.push([netProfitLabel, data.netProfit]);

    // Generate table
    doc.autoTable({
      head: [['Description', 'Amount']],
      body: tableBody,
      startY: 50,
      theme: 'striped',
    });

    // Save the PDF
    doc.save('Income Statement.pdf');

    })
    .catch(error => {
     // alert("There was an error fetching the Business Locations!", error);
    });
};

const generateIncomeStatementHouses = (e) => {
  //alert(business_locationIDGenerateIncomeStatementHouses);
  // Create formData object
  const formData = new FormData();
  if(business_locationIDGenerateIncomeStatementHouses === 'Rentals'){
  formData.append("apiType", 'generateIncomeStatementRentals');
  }
  else{
    formData.append("apiType", 'generateIncomeStatementRentalsLocation');
  }
  //formData.append("userID", userIDGenerateIncomeStatementHouses);
  formData.append("companyID", userCompanyID);
formData.append("startDate", startDateGenerateIncomeStatementHouses);
formData.append("endDate", endDateGenerateIncomeStatementHouses);
formData.append("location", business_locationIDGenerateIncomeStatementHouses);
  // Fetch plot options from the backend using POST method
  console.log('formData Houses', formData)
  axios.post(`${server_app_api_php}/server/index.php`, formData)
    .then(response => {
      //setBusinessLocationsHouses(response.data);
const data = response.data;

console.log('Data Houses', data);

    const doc = new jsPDF();

    // Set document title
    doc.setFontSize(18);
    //doc.text('Income Statement', 105, 20, null, null, 'center');
    if(business_locationIDGenerateIncomeStatementHouses === 'Rentals'){
      doc.text('Income Statement - Rentals', 105, 20, null, null, 'center');
      }
      else{
        doc.text('Income Statement - Rentals  : '+data.location, 105, 20, null, null, 'center');
        }

    // Add date range
    const dateRange = `${startDateGenerateIncomeStatementHouses} To ${endDateGenerateIncomeStatementHouses}`;
    doc.setFontSize(12);
    doc.text(`Period: ${dateRange}`, 105, 30, null, null, 'center');

    // Prepare the table
    const tableBody = [];
    
    // Add income and expenses
    tableBody.push(['INCOME', data.income]);
    tableBody.push(['COST OF SALES', '0']);
    tableBody.push(['GROSS PROFIT', data.income]);

tableBody.push([{ content: 'EXPENSES - RENTALS', colSpan: 2, styles: { fontStyle: 'bold' } }]);
    data.expensesHouses.forEach(expense => {
      tableBody.push([expense.name, expense.amount]);
    });

    const netProfitLabel = data.netProfit < 0 ? 'NET LOSS' : 'NET PROFIT';
    tableBody.push([netProfitLabel, data.netProfit]);

    // Generate table
    doc.autoTable({
      head: [['Description', 'Amount']],
      body: tableBody,
      startY: 50,
      theme: 'striped',
    });

    // Save the PDF
    doc.save('Income Statement Rentals.pdf');

    })
    .catch(error => {
      //alert("There was an error fetching the Business Locations!", error);
    });
};


const generateIncomeStatementPlots = (e) => {
    //alert(business_locationIDGenerateIncomeStatementPlots);
  //const generateIncomeStatementHouses = async () => {
    // Create formData object
    const formData = new FormData();
    if(business_locationIDGenerateIncomeStatementPlots === 'Plots')
      {
    formData.append("apiType", 'generateIncomeStatementPlots');
    }
    else{
      formData.append("apiType", 'generateIncomeStatementPlotsLocation');
    }
    //formData.append("userID", userIDGenerateIncomeStatementHouses);
    formData.append("companyID", userCompanyID);
  formData.append("startDate", startDateGenerateIncomeStatementPlots);
  formData.append("endDate", endDateGenerateIncomeStatementPlots);
  formData.append("location", business_locationIDGenerateIncomeStatementPlots);
  //console.log('formData Plots', formData)
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        //setBusinessLocationsHouses(response.data);
  const data = response.data;
  
  //console.log("userID", userIDGenerateIncomeStatementHouses);
  console.log("companyID", userCompanyID);
  console.log("startDate", startDateGenerateIncomeStatementPlots);
  console.log("endDate", endDateGenerateIncomeStatementPlots);
  console.log("location", business_locationIDGenerateIncomeStatementPlots);
  
  //console.log('Data Plots', data);
  
      const doc = new jsPDF();
  
      // Set document title
      doc.setFontSize(18);
      if(business_locationIDGenerateIncomeStatementPlots === 'Plots'){
      doc.text('Income Statement - Plots', 105, 20, null, null, 'center');
      }
      else{
        doc.text('Income Statement - Plots  : '+data.location, 105, 20, null, null, 'center');
        }
  
      // Add date range
      const dateRange = `${startDateGenerateIncomeStatementPlots} To ${endDateGenerateIncomeStatementPlots}`;
      doc.setFontSize(12);
      doc.text(`Period: ${dateRange}`, 105, 30, null, null, 'center');
  
      // Prepare the table
      const tableBody = [];
      
      // Add income and expenses
      tableBody.push(['INCOME', data.income]);
      tableBody.push(['COST OF SALES', '(0)']);
      tableBody.push(['GROSS PROFIT', data.income]);
  
      tableBody.push([{ content: 'EXPENSES - PLOTS', colSpan: 2, styles: { fontStyle: 'bold' } }]);
      data.expensesPlots.forEach(expense => {
        tableBody.push([expense.name, expense.amount]);
      });
  
     const netProfitLabel = data.netProfit < 0 ? 'NET LOSS' : 'NET PROFIT';
      tableBody.push([netProfitLabel, data.netProfit]);
  
      // Generate table
      doc.autoTable({
        head: [['Description', 'Amount']],
        body: tableBody,
        startY: 50,
        theme: 'striped',
      });
  
      // Save the PDF
      doc.save('Income Statement Plots.pdf');
  
      })
      .catch(error => {
        //alert("There was an error fetching the Business Locations!", error);
      });
  };

/*
  const downloadPOPs = async (category, id) => {
    //alert("Your Download Will Start Soon")
     try {
             const response = await axios.get(server_app_api_php+'/server/downloadPOPs.php?file='+id+'category='+category, {
                 responseType: 'blob'
             });
             if (response.status === 200) {
               //alert(response.data);
                 const blob = new Blob([response.data], { type: 'application/octet-stream' });
                 const downloadLink = document.createElement('a');
                 downloadLink.href = window.URL.createObjectURL(blob);
                 downloadLink.download = fileDoc;
                 document.body.appendChild(downloadLink);
                 downloadLink.click();
                 document.body.removeChild(downloadLink);
             }
         } catch (error) {
             alert('Error downloading file:', error);
         }
         //setFileDoc('')
         //setGivenFile('')
   }
   */
   const [loading, setLoading] = useState(false);  
   const [documentURL, setDocumentURL] = useState(null);
   const [documentType, setDocumentType] = useState(null); // To store the document type

   const [fileType, setFileType] = useState(null);

  const downloadPOPs = async (type, doc) => {
    setLoading(true);
    try {
      const response = await axios.get(`${server_app_api_php}/server/downloadPOPs.php`, {
        responseType: 'blob', // Important to get the file as a blob
        params: { type, doc }
      });

      // Determine the file type from the response headers
      const contentType = response.headers['content-type'];
      setFileType(contentType);

      // Create a URL for the received blob
      const fileURL = URL.createObjectURL(response.data);
      setDocumentURL(fileURL);
      setLoading(false);
    } catch (error) {
      alert('Error fetching the document');
      setLoading(false);
    }
  };

   /*const downloadPOPs = async (type, doc) => {
     try {
       const response = await axios.get(`${server_app_api_php}/server/downloadPOPs.php`, {
         responseType: 'blob', // Important to get the file as a blob
         params: { type, doc }
       });
 
       // Determine the file type from the response's Content-Type header
      const contentType = response.headers['content-type'];
      setDocumentType(contentType);
      //alert(contentType);
       // Create a URL for the received blob
       const fileURL = URL.createObjectURL(response.data);
       setDocumentURL(fileURL);
       // Open the file in a new window or handle it as per your needs
       //window.open(fileURL);
        // Open the file in a new window or handle it as per your needs
      if (contentType.includes('pdf')) {
        // If it's a PDF, open it in a new window
        window.open(fileURL);
      } else if (contentType.includes('image')) {
        // If it's an image, open it in a new window
        window.open(fileURL);
      } else {
        alert('Unsupported file type');
      }
     } catch (error) {
       alert('Error fetching the document', error);
     }
   };*/
   const [customerDetails, setCustomerDetails] = useState({
    amount_paidID: "", 
    businessLocationName: "", 
    customersFirstName: "", 
    customersLastName: "", 
    plotNumber: "", 
    amountPaid: "", 
    datePaid: "",
    authenticationCode: "",
    plots_customersID: "",
  });

   const deleteEntryAmountPaidByPlotCustomer = (amount_paidID, businessLocationName, customersFirstName, customersLastName, plotNumber, amountPaid, datePaid, authenticationCode, plots_customersID) => {
    setCustomerDetails({
      amount_paidID: amount_paidID || "", 
      businessLocationName: businessLocationName || "", 
      customersFirstName: customersFirstName || "", 
      customersLastName: customersLastName || "", 
      plotNumber: plotNumber || "", 
      amountPaid: amountPaid || "", 
      datePaid: datePaid || "",
      authenticationCode: authenticationCode || "",
      plots_customersID: plots_customersID || "",
    });
   };

   const editAmountPaidByPlotCustomer = (amount_paidID, businessLocationName, customersFirstName, customersLastName, plotNumber, amountPaid, datePaid, authenticationCode, plots_customersID) => {
    setCustomerDetails({
      amount_paidID: amount_paidID || "", 
      businessLocationName: businessLocationName || "", 
      customersFirstName: customersFirstName || "", 
      customersLastName: customersLastName || "", 
      plotNumber: plotNumber || "", 
      amountPaid: amountPaid || "", 
      datePaid: datePaid || "",
      authenticationCode: authenticationCode || "",
      plots_customersID: plots_customersID || "",
    });
   };

   const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };


const [changeTheAmountPaid, setChangeTheAmountPaid] = useState(false);
const [requestAuthenticationCode, setRequestAuthenticationCode] = useState(true);
const [verifyAuthenticationCode, setVerifyAuthenticationCode] = useState(false);

  const handleSubmitRequestAuthenticationCode = (e) => {
    const { amount_paidID, businessLocationName, customersFirstName, customersLastName, plotNumber, amountPaid, datePaid } = customerDetails;
  
    if (!amount_paidID || !businessLocationName || !plotNumber || !amountPaid || !datePaid) {
      alert("Amount field should not be empty!");
      return;
    }
    //setChangeTheAmountPaid(false);

    const formData = new FormData();
    formData.append('amount_paidID', amount_paidID);
    formData.append('businessLocationName', businessLocationName);
    formData.append('customersFirstName', customersFirstName);
    formData.append('customersLastName', customersLastName);
    formData.append('plotNumber', plotNumber);
    formData.append('amountPaid', amountPaid);
    formData.append('datePaid', datePaid);
    formData.append('operation', 'Plot Payment');
    formData.append('userID', userID);
    formData.append('apiType', 'requestAuthenticationCodeToChangeAmountPaidPlotCustomer');

    // Send the FormData object using Axios
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        alert(response.data);
        setChangeTheAmountPaid(false);
        setVerifyAuthenticationCode(true);
        setRequestAuthenticationCode(false);
      })
      .catch(error => {
        alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
        setChangeTheAmountPaid(false);
        setVerifyAuthenticationCode(false);
        setRequestAuthenticationCode(true);
      })
     /* .finally(() => {
        setChangeTheAmountPaid(false);
        setRequestAuthenticationCode(true);
      });*/
    

  };

  const handleSubmitVerifyAuthenticationCode = (e) => {
    const { amount_paidID, businessLocationName, customersFirstName, customersLastName, plotNumber, amountPaid, datePaid, authenticationCode } = customerDetails;
  
    if (!amount_paidID || !businessLocationName || !plotNumber || !amountPaid || !datePaid || !authenticationCode) {
      alert("Authentication Code field should not be empty!");
      return;
    }
    //setChangeTheAmountPaid(false);

    const formData = new FormData();
    formData.append('amount_paidID', amount_paidID);
    formData.append('businessLocationName', businessLocationName);
    formData.append('customersFirstName', customersFirstName);
    formData.append('customersLastName', customersLastName);
    formData.append('plotNumber', plotNumber);
    formData.append('amountPaid', amountPaid);
    formData.append('datePaid', datePaid);
    formData.append('operation', 'Plot Payment');
    formData.append('userID', userID);
    formData.append('authCode', authenticationCode);
    formData.append('apiType', 'verifyAuthenticationCodeToChangeAmountPaidPlotCustomer');

    // Send the FormData object using Axios
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        alert(response.data);
        if(response.data === "Code Successfully Verified"){
        setChangeTheAmountPaid(true);
        setVerifyAuthenticationCode(false);
        setRequestAuthenticationCode(false);
        }
        else{
          setChangeTheAmountPaid(false);
          setVerifyAuthenticationCode(true);
          setRequestAuthenticationCode(false);
        }
      })
      .catch(error => {
        alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
        setChangeTheAmountPaid(false);
        setVerifyAuthenticationCode(true);
        setRequestAuthenticationCode(false);
      })    

  };

  const handleSubmitChangeTheAmountPaid = (e) => {
    const { amount_paidID, businessLocationName, customersFirstName, customersLastName, plotNumber, amountPaid, datePaid, authenticationCode, plots_customersID } = customerDetails;
  
    if (!amount_paidID || !businessLocationName || !plotNumber || !amountPaid || !datePaid || !authenticationCode) {
      alert("All fields are required!");
      return;
    }
    //setChangeTheAmountPaid(false);

    const formData = new FormData();
    formData.append('amount_paidID', amount_paidID);
    formData.append('businessLocationName', businessLocationName);
    formData.append('customersFirstName', customersFirstName);
    formData.append('customersLastName', customersLastName);
    formData.append('plotNumber', plotNumber);
    formData.append('amountPaid', amountPaid);
    formData.append('datePaid', datePaid);
    formData.append('operation', 'Plot Payment');
    formData.append('userID', userID);
    formData.append('authCode', authenticationCode);
    formData.append('plots_customersID', plots_customersID);
    formData.append('apiType', 'changeTheAmountPaidByPlotCustomer');

    // Send the FormData object using Axios
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        alert(response.data.message);
        setVerifyAuthenticationCode(false);
        setRequestAuthenticationCode(true);
        setChangeTheAmountPaid(false);
      })
      .catch(error => {
        alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
        setRequestAuthenticationCode(false);
        setVerifyAuthenticationCode(false);
        setChangeTheAmountPaid(true);
      })

  };

  const handleSubmitAuthenticationCodeRefresh = (e) => {
    setChangeTheAmountPaid(false);
    setVerifyAuthenticationCode(false);
    setRequestAuthenticationCode(true);
    setCustomerDetails((prevDetails) => ({
      ...prevDetails,
      authenticationCode: "",  // Reset authentication code
    }));
  };

  /*
  {requestAuthenticationCode &&
  <button className="btn btn-danger" 
onClick={handleSubmitRequestAuthenticationCode} 
>
Request Authentication Code</button>
}

{changeTheAmountPaid &&
<button className="btn btn-danger" 
onClick={handleSubmitChangeTheAmountPaid} 
>Save Changes
</button>
}
  */

  return (
    <>
     <Header />
    
   <main class="bg-white">   
   <hr />
    <div className="container-fluid mt-5" style={{ overflowX: 'auto' }}>

    {/**************Modal For Plot Customer Statement Starts Here****************/}
    <div className="modal fade" id="modalEditAmountPaidByPlotCustomer" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
          aria-hidden="true">
          <div className="modal-dialog modal-fluid modal-notify modal-success" role="document">
            {/* Content */}
            <div className="modal-content">
              {/* Header */}
              <div className="modal-header">
                <p className="heading lead">Edit Amount Paid By Customer</p>

                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" className="white-text">&times;</span>
                </button>
              </div>

              {/* Body */}
              <div className="modal-body ">
               
			    {/* Second column */}
          <div className="col-md-12 col-lg-12 col-xl-12 mb-md-0 mb-5 ">

            {/* Card */}
            <div className="card profile-card ">


              <div className="card-body pt-0 mt-0">                				
                        
              <div className='mt-5'>

              <div className='text-center'>
          <img src={logo} alt="Logo" style={{ width: '120px', height: '60px' }} />
          <h1 className='font-weight-bold text-uppercase'>Edit Customer Payment</h1>
        </div>
                <hr />
                
        <div className='row py-3 morpheus-den-gradient accent-2 white-text'>
    {/* Display current customer details */}
    <div className="col-md-6 text-left">
      <span className="font-weight-bold text-uppercase">Name:</span> {customerDetails.customersLastName +" "+ customerDetails.customersFirstName || '-'}
    </div>
    <div className="col-md-3 text-left">
      <span className="font-weight-bold text-uppercase">Amount Paid(ZMB):</span> {customerDetails.amountPaid || '-'}
    </div>
    <div className="col-md-3 text-left">
      <span className="font-weight-bold text-uppercase">Date:</span> {customerDetails.datePaid || '-'}
    </div>
<hr className='mt-5'/>
    {/* Editable form for customer details */}
   
    {/* Editable form for customer details */}
    <div className="mt-4" >
            <div className="form-group text-left">
              <label htmlFor="lname" className="font-weight-bold text-uppercase">Amount Paid:</label>
              <input
                type="text"
                id="amountPaid"
                name="amountPaid"
                value={customerDetails.amountPaid}
                onChange={handleInputChange}
                className="form-control"
                required
                disabled={!requestAuthenticationCode}
              />
            </div>

            {(changeTheAmountPaid || verifyAuthenticationCode) &&
            <div className="form-group text-left">
            <label htmlFor="authenticationCode" className="font-weight-bold text-uppercase">Authentication Code:</label>
            <input
              type="text"
              id="authenticationCode"
              name="authenticationCode"
              value={customerDetails.authenticationCode}
              onChange={handleInputChange}
              className="form-control"
              required
              disabled={changeTheAmountPaid}
            />
          </div>
}

            <input type="hidden" id="amount_paidID" name="amount_paidID"  value={customerDetails.amount_paidID} onChange={handleInputChange} />
            <input type="hidden" id="businessLocationName" name="businessLocationName"  value={customerDetails.businessLocationName} onChange={handleInputChange} />
            <input type="hidden" id="customersFirstName" name="customersFirstName"  value={customerDetails.customersFirstName} onChange={handleInputChange} />
            <input type="hidden" id="customersLastName" name="customersLastName"  value={customerDetails.customersLastName} onChange={handleInputChange} />
            <input type="hidden" id="plotNumber" name="plotNumber"  value={customerDetails.plotNumber} onChange={handleInputChange} />
            <input type="hidden" id="amountPaid" name="amountPaid"  value={customerDetails.amountPaid} onChange={handleInputChange} />
            <input type="hidden" id="datePaid" name="datePaid"  value={customerDetails.datePaid} onChange={handleInputChange} />
            <input type="hidden" id="plots_customersID" name="plots_customersID"  value={customerDetails.plots_customersID} onChange={handleInputChange} />
            
{requestAuthenticationCode &&
  <button className="btn btn-danger" 
onClick={handleSubmitRequestAuthenticationCode} 
>
Request Authentication Code <FontAwesomeIcon icon={faKey} /></button>
}

{verifyAuthenticationCode &&
  <button className="btn btn-danger" 
onClick={handleSubmitVerifyAuthenticationCode} 
>
Verify Authentication Code <FontAwesomeIcon icon={faCheckCircle} /></button>
}

{changeTheAmountPaid &&
<button className="btn btn-danger" 
onClick={handleSubmitChangeTheAmountPaid} 
>Save Changes <FontAwesomeIcon icon={faSave} />
</button>
}

{(verifyAuthenticationCode || changeTheAmountPaid) &&
<button className="btn btn-dark white-text" 
onClick={handleSubmitAuthenticationCodeRefresh} 
>Refresh <FontAwesomeIcon icon={faRefresh} />
</button>
}

          </div>
   
        </div>
              
              </div>
             
				<div className="row"> </div>
				
			</div>

            </div>
            {/* Card */}

          </div>
          {/* Second column */}
			   
              </div>

              {/* Footer */}
              <div className="modal-footer">
                  <a type="button" className="btn btn-outline-success waves-effect" data-dismiss="modal">Close</a>
            </div>
            </div>
            {/* Content */}
          </div>
        </div>
    {/**************Modal For Plot Customer Statement Ends Here *****************/}
  
 {/* Modal: Generate Filter For Income Statement - Rentals Starts Here*/}
 <div className="modal fade" id="modalShowHousesIncomeStatementFilter" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <p className="heading lead">Generate Income Statement - Rentals</p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="white-text">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" value={business_locationIDGenerateIncomeStatementHouses} onChange={(e) => setBusiness_locationIDGenerateIncomeStatementHouses(e.target.value)}>
                    <option value="">Choose Business Location..</option>
                    <option>All</option>
                    <option>Rentals</option>
                    {businessLocationsHouses.map(location => (
                      <option key={location.businessLocationID} value={location.businessLocationID}>
                        {location.businessLocationName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-5 col-xl-5 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="date" className="form-control form-control-md" value={startDateGenerateIncomeStatementHouses} onChange={(e) => setStartDateGenerateIncomeStatementHouses(e.target.value)} />
                    <label htmlFor="form22">Start Date</label>
                  </div>
                </div>
                <div className="col-lg-2 col-xl-2 col-md-12 md-form md-outline text-right">
                  <label htmlFor="form22">To</label>
                </div>
                <div className="col-lg-5 col-xl-5 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="date" className="form-control form-control-md" value={endDateGenerateIncomeStatementHouses} onChange={(e) => setEndDateGenerateIncomeStatementHouses(e.target.value)}/>
                    <label htmlFor="form22">End Date</label>
                  </div>
                </div>
                <div className="text-center mt-0">
                  <button className="btn btn-success" hidden={business_locationIDGenerateIncomeStatementHouses != 'All'}
                  onClick={() => {
                    generateIncomeStatement("Houses")
                  }}
                  disabled={business_locationIDGenerateIncomeStatementHouses === '' || startDateGenerateIncomeStatementHouses === '' || endDateGenerateIncomeStatementHouses === ''}
                  >Generate <i className="fas fa-eye-alt ml-1"></i></button>
                  <button className="btn btn-success" 
                  onClick={generateIncomeStatementHouses} hidden={business_locationIDGenerateIncomeStatementHouses === 'All'}
                  disabled={business_locationIDGenerateIncomeStatementHouses === '' || startDateGenerateIncomeStatementHouses === '' || endDateGenerateIncomeStatementHouses === ''}
                  >Generate <i className="fas fa-eye-alt ml-1"></i></button>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-danger waves-effect ml-auto" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
  {/* Modal: Generate Filter For Income Statement - Rentals Ends Here*/}
 
      {/* Modal: Generate Filter For Income Statement - Plots Starts Here*/}
      <div className="modal fade" id="modalShowPlotsIncomeStatementFilter" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <p className="heading lead">Generate Income Statement - Plots</p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="white-text">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="business_locationIDGenerateIncomeStatementPlots" value={business_locationIDGenerateIncomeStatementPlots} onChange={(e) => setBusiness_locationIDGenerateIncomeStatementPlots(e.target.value)}>
                    <option value="">Choose Business Location..</option>
                    <option>All</option>
                    <option>Plots</option>
                    {businessLocationsPlots.map(location => (
                      <option key={location.businessLocationID} value={location.businessLocationID}>
                        {location.businessLocationName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-5 col-xl-5 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="date" className="form-control form-control-md" value={startDateGenerateIncomeStatementPlots} onChange={(e) => setStartDateGenerateIncomeStatementPlots(e.target.value)} />
                    <label htmlFor="form22">Start Date</label>
                  </div>
                </div>
                <div className="col-lg-2 col-xl-2 col-md-12 md-form md-outline text-right">
                  <label htmlFor="form22">To</label>
                </div>
                <div className="col-lg-5 col-xl-5 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="date" className="form-control form-control-md" value={endDateGenerateIncomeStatementPlots} onChange={(e) => setEndDateGenerateIncomeStatementPlots(e.target.value)}/>
                    <label htmlFor="form22">End Date</label>
                  </div>
                </div>
                <div className="text-center mt-0">
                  <button className="btn btn-success" hidden={business_locationIDGenerateIncomeStatementPlots != 'All'}
                   onClick={() => {
                    generateIncomeStatement("Plots")
                  }}
                  disabled={business_locationIDGenerateIncomeStatementPlots === '' || startDateGenerateIncomeStatementPlots === '' || endDateGenerateIncomeStatementPlots === ''}
                  >Generate <i className="fas fa-eye-alt ml-1"></i></button>
                  <button className="btn btn-success" onClick={generateIncomeStatementPlots}  hidden={business_locationIDGenerateIncomeStatementPlots === 'All'}
                  disabled={business_locationIDGenerateIncomeStatementPlots === '' || startDateGenerateIncomeStatementPlots === '' || endDateGenerateIncomeStatementPlots === ''}
                  >Generate<i className="fas fa-eye-alt ml-1"></i></button>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-danger waves-effect ml-auto" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
  {/* Modal: Generate Filter For Income Statement - Plots Ends Here*/}

 {/* Modal: Generate Filter For Income Statement - Rentals Starts Here*/}
 <div className="modal fade" id="modalShowPOPs" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <p className="heading lead">View Proof Of Payment</p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="white-text">&times;</span>
              </button>
            </div>
            { loading ? (
                            <>
                        <div class="spinner-grow text-danger" style={{width: '10rem', height: '10rem'}} role="status">
                        </div>
                        </>
                        ) : (<>
            <div className="modal-body">
              
            {documentURL && (
        <div style={{ marginTop: '20px' }}>
          {fileType === 'application/pdf' ? (
            <iframe src={documentURL} width="100%" height="600px" title="PDF Document"></iframe>
          ) : (
            <img src={documentURL} alt="Document" style={{ width: '100%', height: 'auto' }} />
          )}
        </div>
      )}

            </div>

            </>)
          }
            <div className="modal-footer">
              <button type="button" className="btn btn-danger waves-effect ml-auto" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
  {/* Modal: Generate Filter For Income Statement - Rentals Ends Here*/}
 

       <div class="view view-cascade gradient-card-header  ocean blue-gradient">
                  <h2 class="h2-responsive mb-0 font-weight-bold white-text py-5">REAL ESTATE MANAGEMENT</h2>
                </div>

   {/**************Section For Plot Customer Statement Starts Here****************/}
    <div className=""  tabIndex="-1" >
          <div className="fluid notify success" >
            {/* Content */}
            <div className="">

              {/* Body */}
              <div className="body ">
               
			    {/* Second column */}
          <div className="col-md-12 col-lg-12 col-xl-12 mb-md-0 mb-5 ">

            {/* Card */}
            <div className="card profile-card ">

{ userType=== 'Tenant' && (
  
              <div className="card-body pt-0 mt-0">                				
                        
              <div className='mt-5'>
                <div className='row'>
                <div className='col-md-6 text-left'>
              <a type="button" className="btn btn-outline-success waves-effect"
              title='Send PDF To Email'
              onClick={() => {
                generatePDFHouseTenantStatement(nonLoopedItemsHouses, logo, loopedItemsHouses, "Email")
              }}
              >Send Email</a>
              </div>
              <div className='col-md-6 text-right'>
              <a type="button" className="btn btn-outline-success waves-effect" 
              title='Generate PDF'
              onClick={() => {
                generatePDFHouseTenantStatement(nonLoopedItemsHouses, logo, loopedItemsHouses, "Download")
              }}>PDF</a>
              </div>
              </div>

              <div className='text-center'>
          <img src={logo} alt="Logo" style={{ width: '120px', height: '60px' }} />
          <h1 className='font-weight-bold text-uppercase'>Tenant Statement</h1>
        </div>

        
        {Array.isArray(nonLoopedItemsHouses) && nonLoopedItemsHouses.length > 0 && (
          <>
      <div className='row py-3 morpheus-den-gradient accent-2 white-text'>
        <div className='col-md-5 text-left'>         
        <span className='font-weight-bold text-uppercase'>Name:</span> {nonLoopedItemsHouses[0]?.name || '-'}                             
          </div>
          <div className='col-md-2 text-left'>
          <span className='font-weight-bold text-uppercase'>Phone:</span> {nonLoopedItemsHouses[0]?.tenantPhone || '-'} 
          </div>
          <div className='col-md-5 text-left'>
          <span className='font-weight-bold text-uppercase'>Email:</span> {nonLoopedItemsHouses[0]?.tenantEmail || '-'}
        </div>
        </div>  

        <hr />
      
      <div className='row py-3 morpheus-den-gradient accent-2 white-text'>
        <div className="col-md-6 text-left">
          <p>
            <span className="font-weight-bold text-uppercase">
              Location:
            </span>{" "}
            {nonLoopedItemsHouses[0]?.businessLocationName || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              House Number:
            </span>{" "}
            {nonLoopedItemsHouses[0]?.houseNumber || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Block:
            </span>{" "}
            {nonLoopedItemsHouses[0]?.block || "-"}
          </p>
          <p>
           <span className="font-weight-bold text-uppercase">
            Total Amount Paid:
            </span>{" "}
            {formatCurrency(nonLoopedItemsHouses[0]?.rentalsTotalAmountPaid) +
              " (ZMW)" || "-"}
          </p>

        </div>
        <div className="col-md-6 text-left">
          <p>
            <span className="font-weight-bold text-uppercase">
              Rental Price:
            </span>{" "}
            {formatCurrency(nonLoopedItemsHouses[0]?.rentalPrice) +
              " (ZMW)" || "-"}
          </p>          
          <p>
            <span className="font-weight-bold text-uppercase">Balance:</span>{" "}
            {formatCurrency(nonLoopedItemsHouses[0]?.balance) + " (ZMW)" || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Last Date Paid:
            </span>{" "}
            {nonLoopedItemsHouses[0]?.lastDatePaid || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Date Contract Signed:
            </span>{" "}
            {nonLoopedItemsHouses[0]?.dateContractSigned || "-"}
          </p>
        </div>
        </div>
</>

)}
      {Array.isArray(nonLoopedItemsHouses) && nonLoopedItemsHouses.length === 0 && <p>No items available.</p>}
      

<hr />
             
				<div className="row mt-5">
				
<table id="tableHouseTenantStatement"  className="table table-striped table-bordered table-hover table-sm ">
	<thead className="ocean blue-gradient white-text">
                    <tr>
  <th className="font-weight-bold "><strong>SN</strong></th>
                      <th className="font-weight-bold "><strong>Amount (ZMW)</strong></th>
                      <th className="font-weight-bold "><strong>Date</strong></th>
                    </tr>
                  </thead>
	
	<tbody>
  {loopedItemsHouses ? (
                            <>
  {loopedItemsHouses.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{formatCurrencyTable(val.amountPaid)}</td>
                            <td>{val.datePaid}</td>
                            </tr>

                          ))}

</>
                        ) : (
                            <p>Loading  items...</p>
                        )}
    
	</tbody>
	
	<tfoot className='form-header text-center black-text'>
                       
                      </tfoot>
					  
	</table>
	
</div>
				
			</div>
      </div>
      )}
      {(<></>)}

{ userType=== 'Customer' && (
              <div className="card-body pt-0 mt-0">                				
                        
              <div className='mt-5'>
                <div className='row'>
                <div className='col-md-6 text-left'>
              <a type="button" className="btn btn-outline-success waves-effect"
              title='Send PDF To Email'
              onClick={() => {
                generatePDFPlotCustomerStatement(nonLoopedItems, groupedItems, logo, loopedItems, "Email")
              }}
              >Send Email</a>
              </div>
              <div className='col-md-6 text-right'>
              <a type="button" className="btn btn-outline-success waves-effect" 
              title='Generate PDF'
              onClick={() => {
                generatePDFPlotCustomerStatement(nonLoopedItems, groupedItems, logo, loopedItems, "Download")
              }}>PDF</a>
              </div>
              </div>

              <div className='text-center'>
          <img src={logo} alt="Logo" style={{ width: '120px', height: '60px' }} />
          <h1 className='font-weight-bold text-uppercase'>Customer Statement</h1>
        </div>

        <div className='row py-3 morpheus-den-gradient accent-2 white-text'>
        {Array.isArray(nonLoopedItems) && nonLoopedItems.length > 0 && (
          <>
        <div className='col-md-5 text-left'>         
        <span className='font-weight-bold text-uppercase'>Name:</span> {nonLoopedItems[0]?.name || '-'}                             
          </div>
          <div className='col-md-2 text-left'>
          <span className='font-weight-bold text-uppercase'>Phone:</span> {nonLoopedItems[0]?.customersPhone || '-'} 
          </div>
          <div className='col-md-5 text-left'>
          <span className='font-weight-bold text-uppercase'>Email:</span> {nonLoopedItems[0]?.customersEmail || '-'}
        </div>
        </>
      )}
      {Array.isArray(nonLoopedItems) && nonLoopedItems.length === 0 && <p>No items available.</p>}
        </div>
                <hr />

                <>
    {Object.keys(groupedItems).map((plotNumber, index) => (
      <>
      <div key={index} className="row morpheus-den-gradient accent-2 white-text mt-5 mb-5 p-2">
        <div className="col-md-6 text-left">
          <p>
            <span className="font-weight-bold text-uppercase">
              Location:
            </span>{" "}
            {groupedItems[plotNumber][0]?.businessLocationName || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Plot Number:
            </span>{" "}
            {plotNumber || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Plot Area:
            </span>{" "}
            {groupedItems[plotNumber][0]?.plotArea + " (M2)" || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Amount Contributed:
            </span>{" "}
            {formatCurrency(
              groupedItems[plotNumber][0]?.totalAmountPaid
            ) + " (ZMW)" || "-"}
          </p>
         
          <p hidden = {groupedItems[plotNumber][0]?.paidToNHEF === 0 }>
            <span className="font-weight-bold text-uppercase">
            Paid To NHEF:
            </span>{" "}
            {formatCurrency(groupedItems[plotNumber][0]?.paidToNHEF) +
              " (ZMW)" || "-"}
          </p>

          <p>
            <span className="font-weight-bold text-uppercase">
            Total Contributions:
            </span>{" "}
            {formatCurrency(groupedItems[plotNumber][0]?.totalContributions) +
              " (ZMW)" || "-"}
          </p>

        </div>
        <div className="col-md-6 text-left">
          <p>
            <span className="font-weight-bold text-uppercase">
              Plot Price:
            </span>{" "}
            {formatCurrency(groupedItems[plotNumber][0]?.plotPrice) +
              " (ZMW)" || "-"}
          </p>          
          <p>
            <span className="font-weight-bold text-uppercase">Balance:</span>{" "}
            {formatCurrency(groupedItems[plotNumber][0]?.balance) + " (ZMW)" || "-"}
          </p>
          <p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Monthly Installments:
            </span>{" "}
            {formatCurrency(
              groupedItems[plotNumber][0]?.monthlyInstallments
            ) + " (ZMW)" || "-"}
          </p>
            <span className="font-weight-bold text-uppercase">
              Last Date Paid:
            </span>{" "}
            {groupedItems[plotNumber][0]?.lastDatePaid || "-"}
          </p>
          <p>
            <span className="font-weight-bold text-uppercase">
              Date Contract Signed:
            </span>{" "}
            {groupedItems[plotNumber][0]?.dateContractSigned || "-"}
          </p>
        </div>
      </div>

<hr />
</>
    ))}
  </>

                    </div>

             
				<div className="row">
				
<table id="tablePlotCustomerStatement"  className="table table-striped table-bordered table-hover table-sm ">
	<thead className="ocean blue-gradient white-text">
                    <tr>
  <th className="font-weight-bold "><strong>SN</strong></th>
                      <th className="font-weight-bold "><strong>Plot Number</strong></th>
                      <th className="font-weight-bold "><strong>Amount (ZMW)</strong></th>
                      <th className="font-weight-bold "><strong>Date</strong></th>
                    </tr>
                  </thead>
	
	<tbody>
  {loopedItems ? (
                            <>
  {loopedItems.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{val.plotNumber}</td>
                            <td>{formatCurrencyTable(val.amountPaid)}</td>
                            <td>{val.datePaid}</td>
                            </tr>

                          ))}

</>
                        ) : (
                            <p>Loading  items...</p>
                        )}
    
	</tbody>
	
	<tfoot className='form-header text-center black-text'>
                       
                      </tfoot>
					  
	</table>
	
</div>
				
			</div>
      )}
      {(<></>)}

            </div>
            {/* Card */}

          </div>
          {/* Second column */}
			   
              </div>

              {/* Footer */}
              <div className="modal-footer">
             
              </div>
            </div>
            {/* Content */}
          </div>
        </div>

    {/**************Section For Plot Customer Statement Ends Here *****************/}

    { userType != 'Customer' && userType != 'Tenant' && userType != 'Site_Manager' && (
      <>
     {/* <h2>Plots Detailed Statement</h2> */}
      <section className="fixed-sn white-skin">
            <div class="row my-5 pl-5 pr-5">
            { userType != 'Cashier' && userType != 'Developer' && (
      <>
                <div class="col-md-12 col-12">
				  <select class="custom-select d-block w-100" id="business_locationIDMain" name="location"  
          value={business_locationIDMain} onChange={(e) => setBusiness_locationIDMain(e.target.value)}
          >
						<option value="">Choose Business Location..</option>
            {businessLocations.map(location => (
                      <option key={location.businessLocationID} value={location.businessLocationID}>
                        {location.businessLocationName}
                      </option>
                    ))}					
          </select>
						<div class="text-center mt-0">
            <button class="btn btn-success col-12" onClick={business_locationIDMainBTN}>Go</button>
                      </div>	
                </div>
			  <hr />
        </> 
        )}
			  

        <div className="">
              <div className="card mt-5">
                <div className="card-body">

            

                  <div className="">
                    <br />
                    <h2 className="form-header white-text ocean blue-gradient text-uppercase">Plots Detailed Statement</h2>

                    <center>
                    <div id="filterTopCriteria">
                    <button onClick={exportPDFPlotsDetailedStatement} className="btn btn-primary me-2">PDF</button>
                      </div>
                    </center>
                    <table id="table" className="table table-striped table-bordered table-hover table-sm">
                      <thead className="form-header text-uppercase ocean blue-gradient">
                        <tr>
                          <th>S/N</th>
                          <th>Location</th>
                          <th>Name</th>
                          <th>Plot Number</th>
                          <th>Amount Paid (ZMW) </th>
                          <th>Customers Phone</th>
                          <th>Date</th>
                          <th>Action</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {DBtablePlotsDetailedStatement.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{val.businessLocationName}</td>
                            <td align='center'>{val.customersFirstName} {val.customersLastName}</td>
                            <td>{val.plotNumber}</td>
                            <td>{val.amountPaid.toFixed(2)}</td>
                            <td>{val.customersPhone}</td>
                            <td>{val.datePaid}</td>
                            <td>
                          

<ul class="nav navbar-nav nav-flex-icons ml-auto" >
	  <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle waves-effect" href="" id="userDropdown" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="clearfix d-none d-sm-inline-block"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown" style={{width: '500%' }}>
			
            { val.pop != '' ? (
                            <a class="dropdown-item" onClick={() => { downloadPOPs('Plots', val.pop)  }}
               title='View Proof Of Payment'
               data-toggle='modal'
                    data-target='#modalShowPOPs'
               > <span class='fa fa-eye'></span> View Proof Of Payment</a> 
               ) : (<>
               <span class="red-text">Unavailable POP</span>
               </>)
               }

{ userType != 'Cashier' && (
      <>
<a class="dropdown-item"
    data-toggle='modal'
    data-target='#modalEditAmountPaidByPlotCustomer'
    onClick={() => {
      editAmountPaidByPlotCustomer(val.amount_paidID, val.businessLocationName, val.customersFirstName, val.customersLastName, val.plotNumber, val.amountPaid, val.datePaid, val.plots_customersID)
    }}
><span class = "fa fa-edit"></span>Edit Amount Paid By Customer</a>

<a class="dropdown-item"
  data-toggle='modal'
  data-target='#modalDeleteEntryAmountPaidByPlotCustomer'
onClick={() => {
  deleteEntryAmountPaidByPlotCustomer(val.amount_paidID, val.businessLocationName, val.customersFirstName, val.customersLastName, val.plotNumber, val.amountPaid, val.datePaid, val.plots_customersID)
}}
><span class = "fa fa-bin"></span>Delete Entry</a>

</> 
)}
           </div>
          </li></ul>

                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot className="form-header text-center ocean blue-gradient">
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th>TOTAL</th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th>
                            <div className="text-white text-uppercase">
                              <span>Over Total Amount</span>
                            </div>
                          </th>
                          <th>
                          <div className="text-white">
                              <span id="totalOverallPlotsDetailedStatement"></span>
                            </div>
                          </th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      <div hidden>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <CSVLink
            data={filteredDataPlotsDetailedStatement}
            headers={dataPlotsDetailedStatement.columns.map((col) => ({ label: col.label, key: col.field }))}
            filename="plots_detailed_statement.csv"
            className="btn btn-primary me-2"

            hidden
          >
            CSV
          </CSVLink>
          {/*
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="btn btn-primary me-2"
            table="plots-detailed-table"
            filename="plots_detailed_statement"
            sheet="tablexls"
            buttonText="Excel"

            hidden
          />
          */}
          <button onClick={exportPDFPlotsDetailedStatement} className="btn btn-primary me-2">PDF</button>
          <button hidden onClick={handlePrint} className="btn btn-primary">Print</button>
        </div>
        <div className="d-flex align-items-center">
          <label htmlFor="entriesSelect" className="me-2">Show entries:</label>
          <select
            id="entriesSelect"
            value={entriesPlotsDetailedStatement}
            onChange={(e) => setEntriesPlotsDetailedStatement(Number(e.target.value))}
            className="form-select me-3"
            style={{ width: '75px' }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
          </select>
          <input
            type="text"
            placeholder="Search..."
            value={searchValuePlotsDetailedStatement}
            onChange={(e) => handleTableSearch(e.target.value)}
            className="form-control"
            style={{ width: '200px' }}
          />
        </div>
      </div>
      
      </div>
      <hr />
     {/* <h2>Houses Detailed Statement</h2> */}
      <section className="fixed-sn white-skin">
          <div className="">
            <div className="">
              <div className="card mt-5">
                <div className="card-body">
                  <div className="">
                    <br />
                    <h2 className="form-header white-text ocean blue-gradient text-uppercase">Houses Detailed Statement</h2>

                    <center>
                    <div id="filterTopCriteria">
                    <button onClick={exportPDFHousesDetailedStatement} className="btn btn-primary me-2">PDF</button>
                      </div>
                    </center> 
                    <table id="tableHousesDetailedStatement" className="table table-striped table-bordered table-hover table-sm">
                      <thead className="form-header text-uppercase ocean blue-gradient">
                        <tr>
                          <th>S/N</th>
                          <th>Location</th>
                          <th>Name</th>
                          <th>Block</th>
                          <th>House Number</th>
                          <th>Amount Paid (ZMW) </th>
                          <th>Tenant Phone</th>
                          <th>Date</th>
                          <th>View</th>
                        </tr>
                      </thead>
                      <tbody>
                        {DBtableHousesDetailedStatement.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{val.businessLocationName}</td>
                            <td>{val.tenantFirstName} {val.tenantLastName}</td>
                            <td>{val.block}</td>
                            <td>{val.houseNumber}</td>
                            <td>{val.amountPaid.toFixed(2)}</td>
                            <td>{val.tenantPhone}</td>
                            <td>{val.datePaid}</td>
                            <td>
                               { val.pop != '' ? (
                            <span onClick={() => { downloadPOPs('Houses', val.pop)  }}
               type='button' class='fa fa-eye green-text' title='View Proof Of Payment'
                data-toggle='modal'
                    data-target='#modalShowPOPs'
               ></span>
               ) : (<>
               <span>Unavailable</span>
               </>)
               }
                            </td>
                          </tr>
))}
                      </tbody>
                      <tfoot className="form-header text-center ocean blue-gradient">
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th>TOTAL</th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th>
                            <div className="text-white text-uppercase">
                             <span>Over Total Amount</span> 
                            </div>
                          </th>
                          <th>
                          <span className="text-white" id="totalOverallHousesDetailedStatement"></span>
                          </th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div hidden>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <CSVLink
            data={housesFilteredData}
            headers={housesData.columns.map((col) => ({ label: col.label, key: col.field }))}
            filename="houses_detailed_statement.csv"
            className="btn btn-primary me-2"

            hidden
          >
            CSV
          </CSVLink>
          {/*
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="btn btn-primary me-2"
            table="houses-detailed-table"
            filename="houses_detailed_statement"
            sheet="tablexls"
            buttonText="Excel"

            hidden
          />
           */}
          <button onClick={exportPDFHousesDetailedStatement} className="btn btn-primary me-2">PDF</button>
          <button hidden onClick={handlePrintHouses} className="btn btn-primary">Print</button>
        </div>
        <div className="d-flex align-items-center">
          <label htmlFor="housesEntriesSelect" className="me-2">Show entries:</label>
          <select
            id="housesEntriesSelect"
            value={housesEntries}
            onChange={(e) => setHousesEntries(Number(e.target.value))}
            className="form-select me-3"
            style={{ width: '75px' }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
          </select>
          <input
            type="text"
            placeholder="Search..."
            value={housesSearchValue}
            onChange={(e) => handleTableSearchHouses(e.target.value)}
            className="form-control"
            style={{ width: '200px' }}
          />
        </div>
      </div>
      
      </div>
      <hr />
      {/* <h2>Plots Brief Expenses Statement</h2> */}

      { userType != 'Cashier' && (
      <>
      <section className="fixed-sn white-skin">
          <div className="">
            <div className="">
              <div className="card mt-5">
                <div className="card-body">
                  <div className="">
                    <br />
                    <h2 className="form-header white-text ocean blue-gradient text-uppercase">Brief Plots Expenses</h2>

                    <center>
                    <div id="filterTopCriteria">
                    <button
          className="btn btn-danger fa fa-filter white-text"          
          data-toggle='modal'
                    data-target='#modalShowPlotsIncomeStatementFilter'
          >
            Generate Income Statement
          </button>
                    <button onClick={exportPDFPlotsExpenses} className="btn btn-primary me-2">PDF</button>
                      </div>
                    </center>
                    <table id="tablePlotsExpenses" className="table table-striped table-bordered table-hover table-sm">
                      <thead className="form-header text-uppercase ocean blue-gradient">
                        <tr>
                          <th>S/N</th>
                          <th>Location</th>
                          <th>Expenses Amount (ZMW)</th>
                          <th>Monthly Income (ZMW)</th>
                          <th>Balance (ZMW)</th>
                          <th>Date</th>
                          <th>View</th>
                        </tr>
                      </thead>
                      <tbody>
                        {DBtablePlotsExpenses.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{val.businessLocationName}</td>
                            <td>{val.amountPlotsExpenses}</td>
                            <td>{val.amountPaidFromPlots.toFixed(2)}</td>
                            <td>{val.balancePlotsExpenses.toFixed(2)}</td>
                            <td>{val.date}</td>
                            <td></td>
                          </tr>
))}
                      </tbody>
                      <tfoot className="form-header text-center ocean blue-gradient">
                        <tr>
                          <th></th>
                          <th>TOTAL</th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                        <tr>
                          <th></th>
                          <th>
                            <div className="text-white text-uppercase">
                             <span>Over Total Expenses</span> 
                            </div>
                          </th>
                          <th>
                           <span className="text-white" id="totalOverallPlotsExpenses"></span> 
                          </th>
                          <th></th>
                          <th></th>
                          <th></th>
                         
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      <div hidden>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <button
          className="btn btn-danger fa fa-filter white-text"
          >
            Income Statement
          </button>

          <CSVLink
            data={plotsExpensesFilteredData}
            headers={plotsExpensesData.columns.map((col) => ({ label: col.label, key: col.field }))}
            filename="plots_brief_expenses_statement.csv"
            className="btn btn-primary me-2"

            hidden
          >
            CSV
          </CSVLink>
          {/*
          <ReactHTMLTableToExcel
            id="plots-expenses-xls-button"
            className="btn btn-primary me-2"
            table="plots-expenses-table"
            filename="plots_brief_expenses_statement"
            sheet="tablexls"
            buttonText="Excel"

            hidden
          />
           */}
          <button onClick={exportPDFPlotsExpenses} className="btn btn-primary me-2">PDF</button>
          <button hidden onClick={handlePrintPlotsExpenses} className="btn btn-primary">Print</button>
        </div>
        <div className="d-flex align-items-center">
          <label htmlFor="plotsExpensesEntriesSelect" className="me-2">Show entries:</label>
          <select
            id="plotsExpensesEntriesSelect"
            value={plotsExpensesEntries}
            onChange={(e) => setPlotsExpensesEntries(Number(e.target.value))}
            className="form-select me-3"
            style={{ width: '75px' }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
          </select>
          <input
            type="text"
            placeholder="Search..."
            value={plotsExpensesSearchValue}
            onChange={(e) => handleTableSearchPlotsExpenses(e.target.value)}
            className="form-control"
            style={{ width: '200px' }}
          />
        </div>
      </div>
      
</div>
      <hr />
     {/* <h2>Houses Brief Expenses Statement</h2> */}
     <section className="fixed-sn white-skin">
          <div className="">
            <div className="">
              <div className="card mt-5">
                <div className="card-body">
                  <div className="">
                    <br />
                    <h2 className="form-header white-text ocean blue-gradient text-uppercase">Brief Houses Expenses</h2>

                    <center>
                    <div id="filterTopCriteria">
                    <button
          className="btn btn-danger fa fa-filter white-text"
          data-toggle='modal'
          data-target='#modalShowHousesIncomeStatementFilter'
          >
            Generate Income Statement
          </button>
                    <button onClick={exportPDFHousesExpenses} className="btn btn-primary me-2">PDF</button>
                      </div>
                    </center>
                    <table id="tableHousesExpenses" className="table table-striped table-bordered table-hover table-sm">
                      <thead className="form-header text-uppercase ocean blue-gradient">
                        <tr>
                          <th>S/N</th>
                          <th>Location</th>
                          <th>Expenses Amount (ZMW)</th>
                          <th>Monthly Income (ZMW)</th>
                          <th>Balance (ZMW)</th>
                          <th>Date</th>
                          <th>View</th>
                        </tr>
                      </thead>
                      <tbody>
                        {DBtableHousesExpenses.map((val, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{val.businessLocationName}</td>
                            <td>{val.amountHouses}</td>
                            <td>{val.amountPaidFromRentals}</td>
                            <td>{val.balanceFromRentals}</td>
                            <td>{val.date}</td>
                            <td></td>
                          </tr>
))}
                      </tbody>
                      <tfoot className="form-header text-center ocean blue-gradient">
                        <tr>
                          <th></th>
                          <th>TOTAL</th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                        <tr>
                          <th></th>
                          <th>
                            <div className="text-white text-uppercase">
                             <span>Over Total Expenses</span> 
                            </div>
                          </th>
                          <th>
                           <span className="text-white" id="totalOverallHousesExpenses"></span> 
                          </th>
                          <th></th>
                          <th></th>
                          <th></th>
                         
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
</>
)}


     <div hidden>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <button
          className="btn btn-danger fa fa-filter white-text"
          >
            Income Statement
          </button>

          <CSVLink
            data={housesExpensesFilteredData}
            headers={housesExpensesData.columns.map((col) => ({ label: col.label, key: col.field }))}
            filename="houses_brief_expenses_statement.csv"
            className="btn btn-primary me-2"

            hidden
          >
            CSV
          </CSVLink>
          {/*
          <ReactHTMLTableToExcel
            id="houses-expenses-xls-button"
            className="btn btn-primary me-2"
            table="houses-expenses-table"
            filename="houses_brief_expenses_statement"
            sheet="tablexls"
            buttonText="Excel"

            hidden
          />
           */}
          <button onClick={exportPDFHousesExpenses} className="btn btn-primary me-2">PDF</button>
          <button hidden onClick={handlePrintHousesExpenses} className="btn btn-primary">Print</button>
        </div>
        <div className="d-flex align-items-center">
          <label htmlFor="housesExpensesEntriesSelect" className="me-2">Show entries:</label>
          <select
            id="housesExpensesEntriesSelect"
            value={housesExpensesEntries}
            onChange={(e) => setHousesExpensesEntries(Number(e.target.value))}
            className="form-select me-3"
            style={{ width: '75px' }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
          </select>
          <input
            type="text"
            placeholder="Search..."
            value={housesExpensesSearchValue}
            onChange={(e) => handleTableSearchHousesExpenses(e.target.value)}
            className="form-control"
            style={{ width: '200px' }}
          />
        </div>
      </div>
      

      </div>
      </>
      )}
{(<></>)}
    </div>

    </main>

    </>
  );
};

export default Dashboardss;
